import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import SaveAndNavigate from "../../../Components/SaveAndNavigate";
import {
  PageDesignConstants,
  SideMenuItems,
  HTTPResponse,
  ToastMessageType,
  ToastMessages,
  RRMMCohortTreatment,
  NDMMCohortTreatmentID,
  DiscontinuationReason,
} from "../../../Helpers/Enums";
import ErrorField from "../../../Components/ErrorField";
import {
  CommonError_Msgs,
  BispecificCartTreatmentCohort_Msgs,
  hyperlinkTextLineOfTherapy,
} from "../../../Helpers/HelperText";
import { AppContext } from "../../../Contexts/AppContextProvider";
import {
  GetLocalStorageData,
  GetLoggedInUserID,
  IsDateLessThan,
  isStringEmpty,
  IsValidDateValue,
  IsAdmin,
  IsDateAfter,
  IsDateValid,
} from "../../../Helpers/Utilities";
import { BispecificsCartTreatmentCohortService } from "../../../WebApiServices/BispecificsCartTreatmentCohort.service";
import InfoPopUp from "../../../Components/InfoPopUp";
import DatePickerComponent from "../../../Components/DatePickerComponent";
import dayjs from "dayjs";

const BispecificsCartTreatmentCohort = () => {
  const [ndmmAvailable, setNdmmAvailable] = useState(false);
  const navigatePaths = {
    prevPage: ndmmAvailable
      ? "/NDMMTreatmentCohort"
      : "/CohortDefiningTreatment",
    currPage: "/BispecificsCartTreatmentCohort",
    nextPage: "/LineOfTherapy",
  };

  const pid = GetLocalStorageData("patientId") ?? 0;

  const storedData = GetLocalStorageData("CohortTreatment");

  const { ShowActionPopUp } = useContext(AppContext);

  const [showConfirm, setShowConfirm] = useState(false);
  const [endFollowUpDate, setEndFollowUpDate] = useState(null);
  const [intialMMDiagnosisDate, setIntialMMDiagnosisDate] = useState(null);
  const [deathDeath, setDeathDeath] = useState(null);
  const [lastEncounterDate, setLastEncounterDate] = useState(null);
  const [adverseEventsList, setAdverseEventsList] = useState(null);
  const [adverseNeurologicalEventsList, setAdverseNeurologicalEventsList] =
    useState(null);
  const [confirmResolve, setConfirmResolve] = useState(null);

  const [bispecificHighestLotList, setBispecificHighestLotList] = useState([]);
  const [prescribedTreatments, setPrescribedTreatments] = useState([]); //static list of prescribed treatments
  const [prescribedTmtOtherID, setPrescribedTmtOtherID] = useState(null);

  const [modalDescription, setModalDescription] = useState(
    "You have changed the number of Tecvayli or Talquetamab administrations.\nPlease ensure that this change will affect the number of dose administrations (rows) listed in Q36.\nDo you want to continue?",
  );
  const [isNewEcrfA, setIsNewEcrfA] = useState(false);

  const cohortConfig = [
    {
      cohortIds: [
        NDMMCohortTreatmentID.DVRd_TIE,
        NDMMCohortTreatmentID.DVRd_TE,
      ],
      flag: "isDvrd",
    },
    {
      cohortIds: [NDMMCohortTreatmentID.DRd_TIE],
      flag: "isDrd",
    },
    {
      cohortIds: [NDMMCohortTreatmentID.DKRd_TE, NDMMCohortTreatmentID.DKRd_TE],
      flag: "isDkrd",
    },
    {
      cohortIds: [NDMMCohortTreatmentID.VRd_TIE, NDMMCohortTreatmentID.VRd_TE],
      flag: "isVrd",
    },
    {
      cohortIds: [
        NDMMCohortTreatmentID.ISAVRD_TIE,
        NDMMCohortTreatmentID.ISAVRD_TE,
      ],
      flag: "isIsaVrd",
    },
    {
      cohortIds: [RRMMCohortTreatment.TECVAYLI],
      flag: "isTec",
    },
    {
      cohortIds: [RRMMCohortTreatment.TALVEY],
      flag: "isTal",
    },
    {
      cohortIds: [RRMMCohortTreatment.ELREXFIO],
      flag: "isElr",
    },
    {
      cohortIds: [RRMMCohortTreatment.Linvoseltamab],
      flag: "isLyno",
    },
    {
      cohortIds: [RRMMCohortTreatment.CARVYKTI],
      flag: "isCarv",
    },
    {
      cohortIds: [RRMMCohortTreatment.ABECMA],
      flag: "isAbec",
    },
  ];

  const confirmChanges = () => {
    return new Promise((resolve) => {
      setConfirmResolve(() => resolve);
      setShowConfirm(true);
    });
  };

  const handleYes = () => {
    setShowConfirm(false);
    confirmResolve(true);
  };

  const handleNo = () => {
    setShowConfirm(false);
    confirmResolve(false);
  };

  const handleCheckChanges = async () => {
    let TechChanged = false;
    let TalChanged = false;

    bispecificTreatment.forEach((item) => {
      if (
        item.cohorttreatmentid === 9 &&
        item.noOfAdmission !== NumberofAdministrationTecBefore
      ) {
        TechChanged = true;
      } else if (
        item.cohorttreatmentid === 10 &&
        item.noOfAdmission !== NumberofAdministrationTalBefore
      ) {
        TalChanged = true;
      }
    });

    if (TechChanged || TalChanged) {
      const proceed = await confirmChanges(
        "You have changed the number of Tecvayli or Talquetamab administrations. Please ensure that this change will affect the number of dose administrations (rows) listed in Q36. Do you want to continue?",
      );
      return proceed;
    }
    return true;
  };

  const [NumberofAdministrationTecBefore, setNumberofTecAdministrationBefore] =
    useState(null);
  const [NumberofAdministrationTalBefore, setNumberofTalAdministrationBefore] =
    useState(null);

  const [TechAdministrationChanged, setTechAdministrationChanged] =
    useState(false);
  const [TalAdministrationChanged, setTalAdministrationChanged] =
    useState(false);

  let cohortTreatmentModelListt = [];
  let cohortTreatmentModelListtndmm = [];
  if (storedData) {
    cohortTreatmentModelListt = JSON.parse(storedData);
    cohortTreatmentModelListtndmm = cohortTreatmentModelListt.filter(
      (c) => c.isEligible == true && c.ndmm == true,
    );
    cohortTreatmentModelListt = cohortTreatmentModelListt.filter(
      (c) => c.isEligible == true && c.ndmm == false,
    );
  }
  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    registerPageConfig,
    registerSaveFn,
  } = useContext(AppContext);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [showHideHyperlinkModal, setShowHideHyperlinkModal] = useState(false);

  const cartTreatment = {
    bispecificTreatmentcohortid: 0,
    cohorttreatmentid: 0,
    cohortTreatmentName: "",
    AgentId: 0,
    AgentName: "",

    cohortIndexDate: "",
    supscripttext: "",
    endOfFollowUpDate: "",
    lOT: "",
    discontinueAgent: null,
    firstDate: null,
    lastDate: null,
    lastDateRadio: null,
    lastDateUnk: null,
    noOfAdmission: null,
    noOfAdmissionRadio: null,
    noOfAdmissionUnk: null,
    noOfAdmissionUnkTxt: "",
    doseAdministrationRadiomg: null,
    doseAdministrationmg: null,
    doseAdministrationRadiokg: null,
    doseAdministrationkg: null,
    doseAdministrationRadiomgm: null,
    doseAdministrationmgm: null,
    doseAdministrationRadiocell: null,
    doseAdministrationcell: null,
    doseAdministrationRadioUnknown: null,
    reasonForDiscontinuingMedications: [
      {
        bispecificCohortId: 0,
        cohorttreatmentid: 0,
        reasonid: 0,
        reasonName: null,
        reasonText: null,
        supscripttext: "",
        isSelected: false,
        reasonUnk: false,
      },
    ],

    showColBError: false,
    showColBDuplicateLotError: false,
    showColDError: false,
    showColD_SEFDateError: false,
    showColD_LEFDateError: false,
    showColD_DateError: false,
    showColD_EFDateError: false,
    showColD_InvalidDate: false,
    showColEError: false,
    showColEUkTxtError: false,
    showColFError: false,
    showColG: false,
    showColGError: false,
    showColGOthError: false,
    showColHError: false,
    discontinuationSoftError: false,
    lastAdministrationSoftError: false,
    discontinuationUnkSoftError: false,
    showAdverseEventError: false,
    showAdverseNeuroEventError: false,
    showAdverseNeuroEventOtherTextError: false,
    agentDateRangeError: false,
    agentDateError: false,
  };

  const [bispecificTreatment, setbispecificTreatment] = useState([
    cartTreatment,
  ]);

  const [endOfFollowUpDate, setEndOfFollowUpDate] = useState(null); //Date from Cohort Defining page Q20
  const [bispecificAgent, setbispecificAgent] = useState([cartTreatment]);

  //Q26.2
  const BispecificHighestLot = {
    cohorttreatmentid: null,
    cohorttreatmentNdmmid: null,
    cohorttreatmentName: null,
    bindedCohorttreatmentid: null,
    q262_rbl_A: null,
    q262_rbl_B: null,
    q262_date_B: null,
    q262_autodate_B: null,
    q262_rbl_C: null,
    q262_date_C: null,
    q262_autodate_C: null,

    chk_q262_received_tmt: false,
    q262_selectedReceivedTmtList: [],

    q262_rbl_E: null,
    q262_rbl_F: null,

    q262_B_empty_err: false,
    q262_B_invalid_date: false,
    q262_B_unk_err: false,
    q262_B_before_err: false,
    q262_B_before_next_lot_err: false,
    q262_B_beyond_eof_err: false,
    q262_C_unk_err: false,
    q262_C_empty_err: false,
    q262_C_invalid_date: false,
    q262_C_before_err: false,
    q262_C_before_next_lot_err: false,
    q262_C_beyond_eof_err: false,
    q262_D_empty_err: false,
    q262_D_txt_empty_err: false,
    q262_DaraNotSelected_err: false,
    q262_E_empty_err: false,
    q262_F_empty_err: false,

    prescribedTreatments: [],
    prescribedTmtOtherID: null,
  };

  useEffect(() => {
    registerPageConfig({
      activePageId: SideMenuItems.BispecificsCartTreatmentCohort,
      navigatePaths,
    });
  }, [navigatePaths]);

  useLayoutEffect(() => {
    registerSaveFn(SavePage);
  });

  useEffect(() => {
    async function FetchData() {
      //Set previous path
      setNdmmAvailable(cohortTreatmentModelListtndmm.length > 0);

      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await LoadData();

        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const LoadData = async () => {
    try {
      if (pid > 0) {
        const response =
          await BispecificsCartTreatmentCohortService.GetBispecificCartTreatmentCohortData(
            pid,
          );

        if (response?.status === HTTPResponse.OK) {
          const { data } = response;

          setIsNewEcrfA(data.isNewEcrfA ?? false);
          setEndFollowUpDate(data.endOfFollowUpDate);
          setDeathDeath(data.deathDate);
          setLastEncounterDate(data.lastEncounterDate);
          setIntialMMDiagnosisDate(data.initialMMDiagnosisDate);
          if (
            data.adverseEventsDiscontinuationreason &&
            data.adverseEventsDiscontinuationreason.length > 0
          ) {
            setAdverseEventsList(data.adverseEventsDiscontinuationreason);
          }
          if (
            data.adverseNeurologicalEventsDiscontinuationreason &&
            data.adverseNeurologicalEventsDiscontinuationreason.length > 0
          ) {
            setAdverseNeurologicalEventsList(
              data.adverseNeurologicalEventsDiscontinuationreason,
            );
          }
          const cohortTreatmentMap = new Map();
          if (cohortTreatmentModelListt) {
            cohortTreatmentModelListt.forEach((item) => {
              if (item.isEligible) {
                cohortTreatmentMap.set(item.cohortTreatmentID, {
                  cohortTreatmentName: item.cohortTreatmentName,
                  cohortIndexDate: item.cohortIndexDate,
                  cohortTreatmentNameSuperscript:
                    item.cohortTreatmentNameSuperscript,
                  earliestCohortIndexDate: item.earliestCohortIndexDate,
                });
              }
            });
          }

          let repeaterData = [];

          // Check if there is existing Bispecific cart data
          if (
            data.medicationTreatmentLists &&
            data.medicationTreatmentLists.length !== 0
          ) {
            repeaterData = data.medicationTreatmentLists.map((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohortTreatmentId) || {};

              if (item.cohortTreatmentId == 9) {
                setNumberofTecAdministrationBefore(item.noOfAdmission);
              }

              if (item.cohortTreatmentId == 10) {
                setNumberofTalAdministrationBefore(item.noOfAdmission);
              }

              const discontinueAgentsLst =
                item.reasonForDiscontinuingMedications.map((AgentItem) => ({
                  bispecificCohortId: AgentItem.bispecificCohortId,
                  cohorttreatmentid: item.cohortTreatmentId,
                  reasonid: AgentItem.reasonid,
                  reasonName: AgentItem.reasonName,
                  reasonText: AgentItem.reasonText,
                  supscripttext: AgentItem.supscripttext,
                  isSelected: AgentItem.isSelected,
                  reasonUnk: AgentItem.reasonUnk,
                }));

              const adverseEventsDiscontinuationreason =
                item.adverseEventsDiscontinuationreason.map((AgentItem) => ({
                  bispecifictreatmentdiscontinuationreasonaeid:
                    AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                  bispecifictreatmentdiscontinuationreasonaebridgeid:
                    AgentItem.bispecifictreatmentdiscontinuationreasonaebridgeid,
                  bispecifictreatmentcohortid:
                    AgentItem.bispecifictreatmentcohortid,
                  reasonName: AgentItem.reasonName,
                  superscripttext: AgentItem.superscripttext,
                  isSelected: AgentItem.isSelected,
                }));

              const adverseNeuroEventsDiscontinuationreason =
                item.adverseNeurologicalEventsDiscontinuationreason.map(
                  (AgentItem) => ({
                    bispecifictreatmentreasonneurologicalaeid:
                      AgentItem.bispecifictreatmentreasonneurologicalaeid,
                    bispecifictreatmentdiscontinuationreasonaeid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                    bispecifictreatmentdiscontinuationreasonid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonid,
                    bispecifictreatmentcohortid:
                      AgentItem.bispecifictreatmentcohortid,
                    reasonName: AgentItem.reasonName,
                    reasonText: AgentItem.reasonText,
                    isSelected: AgentItem.isSelected,
                  }),
                );

              return {
                cohorttreatmentid: item.cohortTreatmentId,
                cohortTreatmentName:
                  cohortTreatment.cohortTreatmentName || null,
                cohortIndexDate: cohortTreatment.cohortIndexDate || null,
                supscripttext: cohortTreatment.cohortTreatmentNameSuperscript,
                bispecificTreatmentcohortid: item.bispecificTreatmentcohortid,
                endOfFollowUpDate: data.endOfFollowUpDate,
                lOT: item.lot,
                firstDate: cohortTreatment.cohortIndexDate || null,
                lastDate: item.lastDate,
                lastDateRadio: item.lastDateRadio,
                lastDateUnk: item.lastDateUnk,
                noOfAdmission: item.noOfAdmission,
                noOfAdmissionRadio: item.noOfAdmissionRadio,
                noOfAdmissionUnk: item.noOfAdmissionUnk,
                noOfAdmissionUnkTxt: item.noOfAdmissionUnkTxt,
                doseAdministrationRadiomg: item.doseAdministrationRadiomg,
                doseAdministrationmg: item.doseAdministrationmg,
                doseAdministrationRadiokg: item.doseAdministrationRadiokg,
                doseAdministrationkg: item.doseAdministrationkg,
                doseAdministrationRadiomgm: item.doseAdministrationRadiomgm,
                doseAdministrationmgm: item.doseAdministrationmgm,
                doseAdministrationRadiocell: item.doseAdministrationRadiocell,
                doseAdministrationcell: item.doseAdministrationcell,
                doseAdministrationRadioUnknown:
                  item.doseAdministrationRadioUnknown,
                discontinueAgent: item.discontinueAgent,
                reasonForDiscontinuingMedications: discontinueAgentsLst,
                adverseEventsDiscontinuationreason:
                  adverseEventsDiscontinuationreason,
                adverseNeurologicalEventsDiscontinuationreason:
                  adverseNeuroEventsDiscontinuationreason,
                showColBError: false,
                showColBDuplicateLotError: false,
                showColDError: false,
                showColD_SEFDateError: false,
                showColD_LEFDateError: false,
                showColD_DateError: false,
                showColD_EFDateError: false,
                showColD_InvalidDate: false,
                showColEError: false,
                showColEUkTxtError: false,
                showColHError: false,
                showColFError: false,
                showColG: item.discontinueAgent == 1 ? true : false,
                showColGError: false,
                showColGOthError: false,
              };
            });

            // Merge with cohortTreatmentModelListt
            cohortTreatmentModelListt.forEach((cohort) => {
              if (
                !repeaterData.some(
                  (item) => item.cohorttreatmentid === cohort.cohortTreatmentID,
                )
              ) {
                const discontinueAgentsLst =
                  data.reasonForDiscontinuingMedications.map((AgentItem) => ({
                    bispecificCohortId: AgentItem.bispecificCohortId,
                    cohorttreatmentid: cohort.cohortTreatmentID,
                    reasonid: AgentItem.reasonid,
                    reasonName: AgentItem.reasonName,
                    reasonText: AgentItem.reasonText,
                    supscripttext: AgentItem.supscripttext,
                    isSelected: AgentItem.isSelected,
                    reasonUnk: AgentItem.reasonUnk,
                  }));

                const adverseEventsDiscontinuationreason =
                  data.adverseEventsDiscontinuationreason.map((AgentItem) => ({
                    bispecifictreatmentdiscontinuationreasonaeid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                    bispecifictreatmentdiscontinuationreasonaebridgeid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonaebridgeid,
                    bispecifictreatmentcohortid:
                      AgentItem.bispecifictreatmentcohortid,
                    reasonName: AgentItem.reasonName,
                    superscripttext: AgentItem.superscripttext,
                    isSelected: AgentItem.isSelected,
                  }));

                const adverseNeuroEventsDiscontinuationreason =
                  data.adverseNeurologicalEventsDiscontinuationreason.map(
                    (AgentItem) => ({
                      bispecifictreatmentreasonneurologicalaeid:
                        AgentItem.bispecifictreatmentreasonneurologicalaeid,
                      bispecifictreatmentdiscontinuationreasonaeid:
                        AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                      bispecifictreatmentdiscontinuationreasonid:
                        AgentItem.bispecifictreatmentdiscontinuationreasonid,
                      bispecifictreatmentcohortid:
                        AgentItem.bispecifictreatmentcohortid,
                      reasonName: AgentItem.reasonName,
                      reasonText: AgentItem.reasonText,
                      isSelected: AgentItem.isSelected,
                    }),
                  );

                repeaterData.push({
                  cohorttreatmentid: cohort.cohortTreatmentID,
                  cohortTreatmentName: cohort.cohortTreatmentName,
                  cohortIndexDate: cohort.cohortIndexDate,
                  supscripttext: cohort.cohortTreatmentNameSuperscript,
                  endOfFollowUpDate: data.endOfFollowUpDate,
                  bispecificTreatmentcohortid: 0,
                  lOT: null,
                  firstDate: cohort.cohortIndexDate,
                  lastDate: null,
                  lastDateRadio: null,
                  lastDateUnk: null,
                  noOfAdmission: null,
                  noOfAdmissionRadio: null,
                  doseAdministrationRadiomg: null,
                  noOfAdmissionUnk: null,
                  noOfAdmissionUnkTxt: "",
                  doseAdministrationmg: null,
                  doseAdministrationRadiokg: null,
                  doseAdministrationkg: null,
                  doseAdministrationRadiomgm: null,
                  doseAdministrationmgm: null,
                  doseAdministrationRadiocell: null,
                  doseAdministrationRadioUnknown: null,
                  doseAdministrationcell: null,
                  discontinueAgent: null,
                  reasonForDiscontinuingMedications: discontinueAgentsLst,
                  adverseEventsDiscontinuationreason:
                    adverseEventsDiscontinuationreason,
                  adverseNeurologicalEventsDiscontinuationreason:
                    adverseNeuroEventsDiscontinuationreason,
                  showColBError: false,
                  showColBDuplicateLotError: false,
                  showColDError: false,
                  showColD_InvalidDate: false,
                  showColD_SEFDateError: false,
                  showColD_LEFDateError: false,
                  showColD_DateError: false,
                  showColD_EFDateError: false,
                  showColEError: false,
                  showColEUkTxtError: false,
                  showColHError: false,
                  showColFError: false,
                  showColG: false,
                  showColGError: false,
                  showColGOthError: false,
                });
              }
            });

            setbispecificTreatment(repeaterData);
          } else {
            // No bispecificdata

            if (cohortTreatmentModelListt != null) {
              cohortTreatmentModelListt.forEach((cohort) => {
                const discontinueAgentsLst =
                  data.reasonForDiscontinuingMedications.map((AgentItem) => ({
                    bispecificCohortId: AgentItem.bispecificCohortId,
                    cohorttreatmentid: cohort.cohortTreatmentID,
                    reasonid: AgentItem.reasonid,
                    reasonName: AgentItem.reasonName,
                    reasonText: AgentItem.reasonText,
                    supscripttext: AgentItem.supscripttext,
                    isSelected: AgentItem.isSelected,
                    reasonUnk: AgentItem.reasonUnk,
                  }));

                const adverseEventsDiscontinuationreason =
                  data.adverseEventsDiscontinuationreason.map((AgentItem) => ({
                    bispecifictreatmentdiscontinuationreasonaeid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                    bispecifictreatmentdiscontinuationreasonaebridgeid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonaebridgeid,
                    bispecifictreatmentcohortid:
                      AgentItem.bispecifictreatmentcohortid,
                    reasonName: AgentItem.reasonName,
                    superscripttext: AgentItem.superscripttext,
                    isSelected: AgentItem.isSelected,
                  }));

                const adverseNeuroEventsDiscontinuationreason =
                  data.adverseNeurologicalEventsDiscontinuationreason.map(
                    (AgentItem) => ({
                      bispecifictreatmentreasonneurologicalaeid:
                        AgentItem.bispecifictreatmentreasonneurologicalaeid,
                      bispecifictreatmentdiscontinuationreasonaeid:
                        AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                      bispecifictreatmentdiscontinuationreasonid:
                        AgentItem.bispecifictreatmentdiscontinuationreasonid,
                      bispecifictreatmentcohortid:
                        AgentItem.bispecifictreatmentcohortid,
                      reasonName: AgentItem.reasonName,
                      reasonText: AgentItem.reasonText,
                      isSelected: AgentItem.isSelected,
                    }),
                  );

                repeaterData.push({
                  cohorttreatmentid: cohort.cohortTreatmentID,
                  cohortTreatmentName: cohort.cohortTreatmentName,
                  cohortIndexDate: cohort.cohortIndexDate,
                  supscripttext: cohort.cohortTreatmentNameSuperscript,
                  reasonForDiscontinuingMedications: discontinueAgentsLst,
                  adverseEventsDiscontinuationreason:
                    adverseEventsDiscontinuationreason,
                  adverseNeurologicalEventsDiscontinuationreason:
                    adverseNeuroEventsDiscontinuationreason,
                  bispecificTreatmentcohortid: 0,
                  endOfFollowUpDate: data.endOfFollowUpDate,
                  lOT: null,
                  firstDate: cohort.cohortIndexDate,
                  lastDate: null,
                  lastDateRadio: null,
                  lastDateUnk: null,
                  noOfAdmission: null,
                  noOfAdmissionRadio: null,
                  noOfAdmissionUnk: null,
                  noOfAdmissionUnkTxt: "",
                  doseAdministrationRadiomg: null,
                  doseAdministrationmg: null,
                  doseAdministrationRadiokg: null,
                  doseAdministrationkg: null,
                  doseAdministrationRadiomgm: null,
                  doseAdministrationmgm: null,
                  doseAdministrationRadiocell: null,
                  doseAdministrationcell: null,
                  doseAdministrationRadioUnknown: null,
                  discontinueAgent: null,
                  showColBError: false,
                  showColBDuplicateLotError: false,
                  showColDError: false,
                  showColD_InvalidDate: false,
                  showColD_SEFDateError: false,
                  showColD_LEFDateError: false,
                  showColD_DateError: false,
                  showColD_EFDateError: false,
                  showColEError: false,
                  showColEUkTxtError: false,
                  showColFError: false,
                  showColHError: false,
                  showColG: false,
                  showColGError: false,
                  showColGOthError: false,
                });
              });

              setbispecificTreatment(repeaterData);
            }
          }

          if (data.bispecificCartTreatmentAgentList?.length > 0) {
            data.bispecificCartTreatmentAgentList =
              data.bispecificCartTreatmentAgentList.map((cohortItem) => {
                const cohortName =
                  cohortTreatmentModelListt.find(
                    (c) => c.cohortTreatmentID === cohortItem.cohortTreatmentId,
                  )?.cohortTreatmentName ?? "";

                return {
                  ...cohortItem,
                  cohortTreatmentName: cohortName,
                };
              });
          }

          setbispecificAgent(data.bispecificCartTreatmentAgentList);

          //Q26.2
          setEndOfFollowUpDate(data.endOfFollowUpDate);

          if (data.bispecificHighestLot != null) {
            let bispecificHighestList = data.bispecificHighestLot;
            const mappedBispecificHighestLot = bispecificHighestList.map(
              (itemRow) => {
                const cohortData =
                  cohortTreatmentMap.get(itemRow.bindedCohorttreatmentid) || {};
                return {
                  ...BispecificHighestLot,

                  cohorttreatmentid: itemRow.cohorttreatmentid ?? null,
                  cohorttreatmentName: itemRow.cohorttreatmentName ?? null,
                  cohorttreatmentNdmmid: itemRow.cohorttreatmentNdmmid ?? null,
                  bindedCohorttreatmentid:
                    itemRow.bindedCohorttreatmentid ?? null,

                  // LOT DETAILS
                  q262_rbl_A: itemRow.lotnumber ?? null,
                  q262_rbl_B:
                    itemRow.lotStartdate ||
                    !isStringEmpty(itemRow.autoLotStartdate)
                      ? 1
                      : itemRow.lotStartdateUnk
                        ? 99
                        : null,
                  q262_date_B:
                    cohortData &&
                    !isStringEmpty(cohortData.earliestCohortIndexDate)
                      ? cohortData.earliestCohortIndexDate
                      : !isStringEmpty(itemRow.autoLotStartdate)
                        ? itemRow.autoLotStartdate
                        : itemRow.lotStartdate,
                  q262_autodate_B:
                    cohortData &&
                    !isStringEmpty(cohortData.earliestCohortIndexDate)
                      ? cohortData.earliestCohortIndexDate
                      : (itemRow.autoLotStartdate ?? null),
                  q262_rbl_C:
                    itemRow.lotEnddate || !isStringEmpty(itemRow.autoLotEnddate)
                      ? 1
                      : itemRow.lotEnddateUnk
                        ? 99
                        : null,
                  q262_date_C: !isStringEmpty(itemRow.autoLotEnddate)
                    ? itemRow.autoLotEnddate
                    : itemRow.lotEnddate,
                  q262_autodate_C: itemRow.autoLotEnddate ?? null,
                  q262_rbl_E: itemRow.receivedLot ?? null,
                  q262_rbl_F: itemRow.refractoryTreatment ?? null,
                  //Warning messages retain on load
                  q262_B_unk_err: itemRow.lotStartdateUnk ?? false,
                  q262_C_unk_err: itemRow.lotEnddateUnk ?? false,

                  // RECEIVED TREATMENT FLAGS
                  chk_q262_received_tmt: itemRow.receivedLot ?? false,
                  q262_rb_received_tmt_unk:
                    itemRow.treatmentReceivedUnknown ?? false,

                  // SELECTED TREATMENTS LIST
                  q262_selectedReceivedTmtList:
                    itemRow.selectedPrescribedTreatmentList ?? [],
                  q262_B_empty_err: false,
                  q262_B_invalid_date: false,
                  q262_C_empty_err: false,
                  q262_C_invalid_date: false,
                  q262_D_empty_err: false,
                  q262_D_txt_empty_err: false,
                  q262_DaraNotSelected_err: false,
                  q262_E_empty_err: false,
                  q262_F_empty_err: false,

                  prescribedTreatments: itemRow.prescribedTreatmentList,
                  prescribedTmtOtherID:
                    itemRow.prescribedTreatmentList
                      ?.find((item) => item.category === null)
                      ?.treatments?.find((tmt) =>
                        tmt.name?.includes("Other, please specify"),
                      )?.prescribedTreatmentId ?? null,
                };
              },
            );

            setBispecificHighestLotList(mappedBispecificHighestLot);
          }
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  };

  const HandleRepeaterFieldChange = (
    e,
    agentName,
    reasonName,
    parentIdx,
    itemidx,
    aeIdx = null,
    aeNeuroIdx = null,
  ) => {
    let { name, id, value } = e.target;
    let updatedArray = [...bispecificTreatment];
    const index = id.split("_").pop(); // Extract the index from the id

    const cohortIndex = parentIdx ?? Number(id.split("_").pop());

    // find agent index inside agentLists
    const agentIndex = updatedArray[cohortIndex]?.agentLists?.findIndex(
      (a) => a.agentName === agentName,
    );

    if (agentIndex === -1) return;

    switch (name) {
      case `q26b_${agentName}_lottxt_${index}`:
        {
          const highestLotIndex = updatedArray.reduce(
            (maxIndex, item, index, arr) =>
              Number(item.lOT) > Number(arr[maxIndex].lOT) ? index : maxIndex,
            0,
          );
          //updatedArray[highestLotIndex].discontinueAgent =!isStringEmpty(value) ? (Number(value)> updatedArray[highestLotIndex].lOT?(updatedArray[highestLotIndex].discontinueAgent===2?"":updatedArray[highestLotIndex].discontinueAgent):updatedArray[highestLotIndex].discontinueAgent):updatedArray[highestLotIndex].discontinueAgent;

          updatedArray[highestLotIndex].discontinueAgent =
            !isStringEmpty(value) &&
            Number(value) > Number(updatedArray[highestLotIndex].lOT) &&
            updatedArray[highestLotIndex].discontinueAgent === 2
              ? ""
              : updatedArray[highestLotIndex].discontinueAgent;

          updatedArray[index].lOT = !isStringEmpty(value) ? Number(value) : "";
          updatedArray[index].showColBError = false;
          updatedArray[index].showColBDuplicateLotError = false;
          SavePage(false);
        }
        break;
      case `q26d_LRadio_${agentName}_${index}`:
        updatedArray[index].lastDateRadio = 1;
        updatedArray[index].lastDate = null;
        updatedArray[index].lastDateUnk = "";
        updatedArray[index].showColDError = false;
        updatedArray[index].showColD_SEFDateError = false;
        updatedArray[index].showColD_LEFDateError = false;
        updatedArray[index].showColD_DateError = false;

        updatedArray[index].showColD_EFDateError = false;
        updatedArray[index].showColD_InvalidDate = false;
        break;
      case `q26d_${agentName}_LUnk_${index}`:
        {
          updatedArray[index].lastDateRadio = "";
          updatedArray[index].lastDate = null;
          updatedArray[index].lastDateUnk = Number(value);
          updatedArray[index].showColDError = false;
          updatedArray[index].showColD_SEFDateError = false;
          updatedArray[index].showColD_LEFDateError = false;
          updatedArray[index].showColD_DateError = false;

          updatedArray[index].showColD_EFDateError = false;
          updatedArray[index].showColD_InvalidDate = false;

          if (agentName == "Talquetamab" && Number(value) != 1) {
            setTalAdministrationChanged(true);
          }
        }
        break;
      case `q26e_${agentName}_Noa_${index}`:
        {
          updatedArray[index].noOfAdmissionRadio = Number(value);
          updatedArray[index].noOfAdmission = "";
          updatedArray[index].noOfAdmissionUnk = "";
          updatedArray[index].noOfAdmissionUnkTxt = "";
          updatedArray[index].showColEError = false;
          updatedArray[index].showColEUkTxtError = false;
        }
        break;
      case `q26e_${agentName}_Noatxt_${index}`:
        {
          updatedArray[index].noOfAdmissionRadio = 1;
          updatedArray[index].noOfAdmission = !isStringEmpty(value)
            ? Number(value)
            : "";
          updatedArray[index].noOfAdmissionUnk = "";
          updatedArray[index].noOfAdmissionUnkTxt = "";
          updatedArray[index].showColEError = false;
          updatedArray[index].showColEUkTxtError = false;
        }
        break;
      case `q26e_${agentName}_NoaUnk_${index}`:
        {
          updatedArray[index].noOfAdmissionRadio = "";
          updatedArray[index].noOfAdmission = "";
          updatedArray[index].noOfAdmissionUnk = Number(value);
          updatedArray[index].noOfAdmissionUnkTxt = "";
          updatedArray[index].showColEError = false;
          updatedArray[index].showColEUkTxtError = false;
        }
        break;
      case `q26e_${agentName}_NoaUnktxt_${index}`:
        {
          updatedArray[index].noOfAdmissionRadio = "";
          updatedArray[index].noOfAdmission = "";
          updatedArray[index].noOfAdmissionUnk = 1;
          updatedArray[index].noOfAdmissionUnkTxt = value;
          updatedArray[index].showColEError = false;
          updatedArray[index].showColEUkTxtError = false;
        }
        break;
      case `q26h1_${agentName}_mg_${index}`:
        {
          updatedArray[index].doseAdministrationRadiomg = Number(value);
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h1_${agentName}_mgtxt_${index}`:
        {
          updatedArray[index].doseAdministrationRadiomg = 1;
          updatedArray[index].doseAdministrationmg = value; // !isStringEmpty(value) ? Number(value) : "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h2_${agentName}_kg_${index}`:
        {
          updatedArray[index].doseAdministrationRadiokg = Number(value);
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h2_${agentName}_kgtxt_${index}`:
        {
          updatedArray[index].doseAdministrationRadiokg = 1;
          updatedArray[index].doseAdministrationkg = value; // !isStringEmpty(value) ? Number(value) : "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h3_${agentName}_m_${index}`:
        {
          updatedArray[index].doseAdministrationRadiomgm = Number(value);
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h3_${agentName}_mtxt_${index}`:
        {
          updatedArray[index].doseAdministrationRadiomgm = 1;
          updatedArray[index].doseAdministrationmgm = value; // !isStringEmpty(value) ? Number(value) : "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h4_${agentName}_cell_${index}`:
        {
          updatedArray[index].doseAdministrationRadiocell = Number(value);
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h4_${agentName}_celltxt_${index}`:
        {
          updatedArray[index].doseAdministrationRadiocell = 1;
          updatedArray[index].doseAdministrationcell = value; // !isStringEmpty(value) ? Number(value) : "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h4_${agentName}_doseUnk_${index}`:
        {
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadioUnknown = Number(value);
          updatedArray[index].showColHError = false;
        }
        break;

      case `q26f_${agentName}_PdaYes_${index}`:
      case `q26f_${agentName}_PdaNo_${index}`:
      case `q26f_${agentName}_PdaUnk_${index}`:
        {
          updatedArray[index].discontinueAgent = Number(value);
          updatedArray[index].showColFError = false;
          updatedArray[index].showColGError = false;
          updatedArray[index].showColGOthError = false;
          updatedArray[index].showColG = Number(value) === 1 ? true : false;
          if (Number(value) !== 1)
            updatedArray[index].reasonForDiscontinuingMedications =
              updatedArray[index].reasonForDiscontinuingMedications.map(
                (item) => {
                  return { ...item, isSelected: false, reasonUnk: "" };
                },
              );
        }
        break;

      case `discont_${agentName}_${reasonName}_${itemidx}`:
        {
          updatedArray[parentIdx].reasonForDiscontinuingMedications[
            itemidx
          ].cohorttreatmentid = updatedArray[parentIdx].cohorttreatmentid;
          updatedArray[parentIdx].reasonForDiscontinuingMedications[
            itemidx
          ].isSelected =
            !updatedArray[parentIdx].reasonForDiscontinuingMedications[itemidx]
              .isSelected;
          updatedArray[
            parentIdx
          ].reasonForDiscontinuingMedications[0].reasonUnk = "";
          updatedArray[parentIdx].showColGError = false;
          updatedArray[parentIdx].showColGOthError = false;

          if (reasonName === DiscontinuationReason.AdverseEvent) {
            const aeList =
              updatedArray[parentIdx].adverseEventsDiscontinuationreason;
            if (aeList?.length) {
              aeList.forEach((ae) => {
                ae.isSelected = false;
              });
            }
            const aeNeuroList =
              updatedArray[parentIdx]
                .adverseNeurologicalEventsDiscontinuationreason;
            if (aeNeuroList?.length) {
              aeNeuroList.forEach((ae) => {
                ae.isSelected = false;
              });
            }
          }

          if (
            updatedArray[parentIdx].reasonForDiscontinuingMedications[
              itemidx
            ].reasonName.includes("Other")
          ) {
            if (
              updatedArray[parentIdx].reasonForDiscontinuingMedications[itemidx]
                .isSelected == false
            )
              updatedArray[parentIdx].reasonForDiscontinuingMedications[
                itemidx
              ].reasonText = "";
          }
        }
        break;
      case `discont_unk_${agentName}_${parentIdx}`:
        {
          updatedArray[parentIdx].showColGError = false;
          updatedArray[parentIdx].showColGOthError = false;
          updatedArray[parentIdx].reasonForDiscontinuingMedications =
            updatedArray[parentIdx].reasonForDiscontinuingMedications.map(
              (item) => {
                return {
                  ...item,
                  isSelected: false,
                  reasonUnk: 1,
                  reasonText: "",
                };
              },
            );

          updatedArray[parentIdx].adverseEventsDiscontinuationreason =
            updatedArray[parentIdx].adverseEventsDiscontinuationreason.map(
              (r) => ({
                ...r,
                isSelected: false,
              }),
            );

          updatedArray[
            parentIdx
          ].adverseNeurologicalEventsDiscontinuationreason = updatedArray[
            parentIdx
          ].adverseNeurologicalEventsDiscontinuationreason.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: true,
            reasonText: "",
          }));
        }
        break;
      case `discont_${agentName}_${reasonName}txt_${itemidx}`:
        {
          updatedArray[parentIdx].showColGError = false;
          updatedArray[parentIdx].showColGOthError = false;
          updatedArray[
            parentIdx
          ].reasonForDiscontinuingMedications[0].reasonUnk = "";
          updatedArray[parentIdx].reasonForDiscontinuingMedications[
            itemidx
          ].isSelected = updatedArray[
            parentIdx
          ].reasonForDiscontinuingMedications[itemidx].reasonName.includes(
            "Other",
          )
            ? true
            : false;

          if (value.length <= 300) {
            updatedArray[parentIdx].reasonForDiscontinuingMedications[
              itemidx
            ].reasonText = value;
          } else {
            updatedArray[parentIdx].reasonForDiscontinuingMedications[
              itemidx
            ].reasonText = value.substring(0, 300);
          }
        }
        break;

      case `adverse_${agentName}_${parentIdx}_${itemidx}_${aeIdx}`: {
        const aeList =
          updatedArray[parentIdx].adverseEventsDiscontinuationreason;

        if (!aeList) return;
        const selectedAE = aeList[aeIdx];

        const isAEUnknown = selectedAE.reasonName === "AE type unknown";

        if (isAEUnknown) {
          // Radio behavior
          aeList.forEach((ae) => (ae.isSelected = false));
          selectedAE.isSelected = true;
        } else {
          // Checkbox behavior
          aeList.forEach((ae) => {
            if (ae.reasonName === "AE type unknown") {
              ae.isSelected = false;
            }
          });
          selectedAE.isSelected = !selectedAE.isSelected;
        }

        break;
      }
      case `adverse_${agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`: {
        const aeNeuroList =
          updatedArray[parentIdx]
            .adverseNeurologicalEventsDiscontinuationreason;
        const aeList =
          updatedArray[parentIdx].adverseEventsDiscontinuationreason;

        if (!aeNeuroList) return;
        const reasonae = aeList[aeIdx];
        const selectedAENeuro = aeNeuroList[aeNeuroIdx];

        selectedAENeuro.isSelected = !selectedAENeuro.isSelected;

        // Keep parent reason selected
        reasonae.isSelected = true;

        break;
      }
      case `discont_${agentName}_${reasonName}txt_${itemidx}_${aeNeuroIdx}`: {
        const aeNeuroList =
          updatedArray[parentIdx]
            .adverseNeurologicalEventsDiscontinuationreason;
        aeNeuroList.isSelected = true;
        aeNeuroList.reasonText =
          value.length <= 300 ? value : value.slice(0, 300);

        if (!aeNeuroList) return;
        const selectedAENeuro = aeNeuroList[aeNeuroIdx];

        selectedAENeuro.isSelected = true;
        selectedAENeuro.reasonText = aeNeuroList.reasonText;

        break;
      }

      default:
        break;
    }
    setbispecificTreatment(updatedArray);
  };

  const HandleQ26OneRepeaterFieldChange = (
    e,
    agentName,
    reasonName,
    parentIdx,
    itemidx,
    aeIdx = null,
    aeNeuroIdx = null,
  ) => {
    const { name, id, value } = e.target;
    const storedData = GetLocalStorageData("CohortTreatment");
    const updatedArray = [...bispecificAgent];
    const cohortIndex = parentIdx ?? Number(id.split("_").pop());

    // find agent index inside agentLists
    const agentIndex = updatedArray[cohortIndex].agentLists.findIndex(
      (a) => a.agentName === agentName,
    );

    if (agentIndex === -1) return;

    const agent = updatedArray[cohortIndex].agentLists[agentIndex];

    switch (name) {
      /* ---------- Last date of administration ---------- */
      case `q26_one_date_last_admin_radio_${agentName}_${cohortIndex}`: {
        agent.lastDateRadio = 1;
        agent.lastDateUnk = "";
        agent.showColDError = false;
        break;
      }

      case `q26_one_${agentName}_LUnk_${cohortIndex}`: {
        agent.lastDateRadio = null;
        agent.lastDate = null;
        agent.lastDateUnk = Number(value);
        agent.showColDError = false;
        break;
      }

      /* ---------- Number of administrations ---------- */
      case `q26_one_${agentName}_No_Admin_${cohortIndex}`: {
        agent.noOfAdmissionRadio = 1;
        agent.noOfAdmission = null;
        agent.noOfAdmissionUnk = null;
        agent.noOfAdmissionUnkTxt = "";
        agent.showColEError = false;
        agent.showColEUkTxtError = false;
        break;
      }

      case `q26_one_${agentName}_No_Admintxt_${cohortIndex}`: {
        agent.noOfAdmissionRadio = 1;
        agent.noOfAdmission = value ? Number(value) : "";
        agent.noOfAdmissionUnk = "";
        agent.noOfAdmissionUnkTxt = "";
        agent.showColEError = false;
        agent.showColEUkTxtError = false;
        break;
      }

      case `q26_one_${agentName}_No_Admin_Unk_${cohortIndex}`: {
        agent.noOfAdmissionRadio = null;
        agent.noOfAdmission = "";
        agent.noOfAdmissionUnk = 1;
        agent.noOfAdmissionUnkTxt = "";
        agent.showColEError = false;
        agent.showColEUkTxtError = false;
        break;
      }

      case `q26_one_${agentName}_No_Admin_Unktxt_${cohortIndex}`: {
        agent.noOfAdmissionRadio = "";
        agent.noOfAdmission = "";
        agent.noOfAdmissionUnk = 1;
        agent.noOfAdmissionUnkTxt = value;
        agent.showColEError = false;
        agent.showColEUkTxtError = false;
        break;
      }

      /* ---------- Dose administration ---------- */
      case `q26_one_${agentName}_mg_${cohortIndex}`: {
        agent.doseAdministrationRadiomg = 1;
        //  agent.doseAdministrationmg = "";
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.doseAdministrationkg = "";
        agent.doseAdministrationmgm = "";
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_mgtxt_${cohortIndex}`: {
        agent.doseAdministrationRadiomg = 1;
        agent.doseAdministrationmg = value;
        agent.doseAdministrationkg = "";
        agent.doseAdministrationmgm = "";
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_kg_${cohortIndex}`: {
        agent.doseAdministrationRadiokg = 1;
        // agent.doseAdministrationkg = "";
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationmgm = "";
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_kgtxt_${cohortIndex}`: {
        agent.doseAdministrationRadiokg = 1;
        agent.doseAdministrationkg = value;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationmgm = "";
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_m_${cohortIndex}`: {
        agent.doseAdministrationRadiomgm = 1;
        //agent.doseAdministrationmgm = "";
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationkg = "";
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_mtxt_${cohortIndex}`: {
        agent.doseAdministrationRadiomgm = 1;
        agent.doseAdministrationmgm = value;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationkg = "";
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_doseUnk_${cohortIndex}`: {
        agent.doseAdministrationRadioUnknown = 99;
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationkg = "";
        agent.doseAdministrationmgm = "";
        agent.showColHError = false;
        break;
      }

      /* ---------- Discontinue agent ---------- */
      case `q26_1_${agentName}_PdaYes_${cohortIndex}`:
      case `q26_1_${agentName}_PdaNo_${cohortIndex}`:
      case `q26_one_${agentName}_PdaUnk_${cohortIndex}`: {
        agent.discontinueAgent = Number(value);
        agent.showColG = Number(value) === 1;
        agent.showColFError = false;

        if (Number(value) !== 1) {
          agent.reasonForDiscontinuingMedications =
            agent.reasonForDiscontinuingMedications.map((r) => ({
              ...r,
              isSelected: false,
              reasonUnk: false,
              reasonText: "",
            }));
        }

        if (Number(value) == 2 && agent.lastDateUnk) {
          agent.lastAdministrationSoftError = true;
        } else {
          agent.lastAdministrationSoftError = false;
        }
        break;
      }

      /* ---------- Reasons for discontinuation ---------- */
      case `discont_${agentName}_${reasonName}_${itemidx}`: {
        const reason = agent.reasonForDiscontinuingMedications[itemidx];
        reason.isSelected = !reason.isSelected;
        agent.showColGError = false;
        agent.showColGOthError = false;

        if (
          reason.reasonName === DiscontinuationReason.PatientDeath &&
          reason.isSelected &&
          !deathDeath // <-- adjust to your actual Q20 field
        ) {
          // show validation error (example)
          agent.discontinuationSoftError = true;
        } else {
          agent.discontinuationSoftError = false;
        }

        // 🔹 CLEAR adverse events when unselected
        if (
          reason.reasonName === DiscontinuationReason.AdverseEvent &&
          !reason.isSelected
        ) {
          const aeList = agent.adverseEventsDiscontinuationreason;
          if (aeList?.length) {
            aeList.forEach((ae) => {
              ae.isSelected = false;
            });
          }
          const aeNeuroList =
            agent.adverseNeurologicalEventsDiscontinuationreason;
          if (aeNeuroList?.length) {
            aeNeuroList.forEach((ae) => {
              ae.isSelected = false;
            });
          }
        }

        agent.reasonForDiscontinuingMedications[0].reasonUnk = false;
        if (reason.reasonName.includes("Other") && !reason.isSelected) {
          reason.reasonText = "";
        }

        agent.discontinuationUnkSoftError = false;
        break;
      }

      case `discont_unk_${agentName}_${cohortIndex}`: {
        agent.showColGError = false;
        agent.showColGOthError = false;
        agent.reasonForDiscontinuingMedications =
          agent.reasonForDiscontinuingMedications.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: true,
            reasonText: "",
          }));

        agent.adverseEventsDiscontinuationreason =
          agent.adverseEventsDiscontinuationreason.map((r) => ({
            ...r,
            isSelected: false,
          }));

        agent.adverseNeurologicalEventsDiscontinuationreason =
          agent.adverseNeurologicalEventsDiscontinuationreason.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: true,
            reasonText: "",
          }));

        agent.discontinuationUnkSoftError = true;
        break;
      }

      case `discont_${agentName}_${reasonName}txt_${itemidx}`: {
        const reason = agent.reasonForDiscontinuingMedications[itemidx];
        reason.isSelected = true;
        reason.reasonText = value.length <= 300 ? value : value.slice(0, 300);
        agent.reasonForDiscontinuingMedications[0].reasonUnk = false;
        agent.discontinuationUnkSoftError = false;
        agent.showColGError = false;
        agent.showColGOthError = false;
        break;
      }

      case `adverse_${agentName}_${itemidx}_${aeIdx}`: {
        const aeList = agent.adverseEventsDiscontinuationreason;

        if (!aeList) return;
        const reason = agent.reasonForDiscontinuingMedications[itemidx];
        const selectedAE = aeList[aeIdx];

        const isAEUnknown = selectedAE.reasonName === "AE type unknown";

        if (isAEUnknown) {
          // Radio behavior
          aeList.forEach((ae) => (ae.isSelected = false));
          selectedAE.isSelected = true;
        } else {
          // Checkbox behavior
          aeList.forEach((ae) => {
            if (ae.reasonName === "AE type unknown") {
              ae.isSelected = false;
            }
          });
          selectedAE.isSelected = !selectedAE.isSelected;
        }

        // Keep parent reason selected
        reason.isSelected = true;
        agent.reasonForDiscontinuingMedications[0].reasonUnk = false;
        agent.discontinuationUnkSoftError = false;
        agent.discontinuationSoftError = false;
        agent.showAdverseEventError = false;

        break;
      }

      case `adverse_${agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`: {
        const aeNeuroList =
          agent.adverseNeurologicalEventsDiscontinuationreason;
        const aeList = agent.adverseEventsDiscontinuationreason;

        if (!aeNeuroList) return;
        const reasonae = aeList[aeIdx];
        const selectedAENeuro = aeNeuroList[aeNeuroIdx];

        selectedAENeuro.isSelected = !selectedAENeuro.isSelected;

        // Keep parent reason selected
        reasonae.isSelected = true;
        agent.discontinuationUnkSoftError = false;
        agent.discontinuationSoftError = false;
        agent.showAdverseEventError = false;
        agent.showAdverseNeuroEventError = false;
        agent.showAdverseNeuroEventOtherTextError = false;

        break;
      }

      case `discont_${agentName}_${reasonName}txt_${itemidx}_${aeNeuroIdx}`: {
        const aeNeuroList =
          agent.adverseNeurologicalEventsDiscontinuationreason;
        aeNeuroList.isSelected = true;
        aeNeuroList.reasonText =
          value.length <= 300 ? value : value.slice(0, 300);

        if (!aeNeuroList) return;
        const selectedAENeuro = aeNeuroList[aeNeuroIdx];

        selectedAENeuro.isSelected = true;
        selectedAENeuro.reasonText = aeNeuroList.reasonText;

        agent.discontinuationUnkSoftError = false;
        agent.discontinuationSoftError = false;
        agent.showAdverseNeuroEventError = false;
        agent.showAdverseNeuroEventOtherTextError = false;
        break;
      }
      default:
        break;
    }
    setbispecificAgent(updatedArray);
  };

  const HandleQ26OneDateChange = (name, date, agentName) => {
    const updatedArray = [...bispecificAgent];
    const cohortIndex = Number(name.split("_").pop());
    // find agent index inside agentLists
    const agentIndex = updatedArray[cohortIndex].agentLists.findIndex(
      (a) => a.agentName === agentName,
    );

    if (agentIndex === -1) return;

    const agent = updatedArray[cohortIndex].agentLists[agentIndex];

    switch (name) {
      case `q26_one_last_admin_date_${cohortIndex}`:
        agent.lastDateRadio = 1;
        agent.lastDate = date;
        agent.lastDateUnk = "";
        agent.showColDError = false;
        agent.showColD_SEFDateError = false;
        agent.showColD_LEFDateError = false;
        agent.showColD_DateError = false;
        agent.showColD_EFDateError = false;
        agent.showColD_InvalidDate = false;
        break;

      default:
        break;
    }
    setbispecificAgent(updatedArray);
  };

  const HandleDateChange = (name, date, optionId, monthOrYearSelect) => {
    let updatedArray = [...bispecificTreatment];
    const idx = name.split("_").pop();

    switch (name) {
      case `q26d_LDate_${idx}`:
        updatedArray[idx].lastDateRadio = 1;
        updatedArray[idx].lastDate = date;
        updatedArray[idx].lastDateUnk = "";
        updatedArray[idx].showColDError = false;
        updatedArray[idx].showColD_SEFDateError = false;
        updatedArray[idx].showColD_LEFDateError = false;
        updatedArray[idx].showColD_DateError = false;

        updatedArray[idx].showColD_EFDateError = false;
        updatedArray[idx].showColD_InvalidDate = false;
        break;

      default:
        break;
    }
    setbispecificTreatment(updatedArray);
  };

  const SavePage = async (validate, showSucessMsg = true) => {
    try {
      //
      let isValid = validate ? ValidateRepeaterData(bispecificTreatment) : true;
      // Wait for user confirmation if changes detected
      const canContinue = await handleCheckChanges(bispecificTreatment);
      if (!canContinue) {
        ToggleLoader(false);
        return; // user clicked No, stop execution
      }

      if (isValid) {
        ToggleLoader(true);
        setShowTopErrMsg(false);

        const RRMMData = bispecificTreatment.map((item) => ({
          cohorttreatmentid: item.cohorttreatmentid,
          cohortTreatmentName: item.cohortTreatmentName || null,
          cohortIndexDate: item.cohortIndexDate || null,
          supscripttext: item.cohortTreatmentNameSuperscript,
          bispecificTreatmentcohortid: item.bispecificTreatmentcohortid,
          lOT: item.lOT,
          firstDate: item.firstDate,
          lastDate: item.lastDate,
          lastDateRadio: item.lastDateRadio,
          lastDateUnk: item.lastDateUnk,
          noOfAdmission: item.noOfAdmission,
          noOfAdmissionRadio: item.noOfAdmissionRadio,
          noOfAdmissionUnk: item.noOfAdmissionUnk,
          noOfAdmissionUnkTxt: item.noOfAdmissionUnkTxt,
          doseAdministrationRadiomg: item.doseAdministrationRadiomg,
          doseAdministrationmg: item.doseAdministrationmg,
          doseAdministrationRadiokg: item.doseAdministrationRadiokg,
          doseAdministrationkg: item.doseAdministrationkg,
          doseAdministrationRadiomgm: item.doseAdministrationRadiomgm,
          doseAdministrationmgm: item.doseAdministrationmgm,
          doseAdministrationRadiocell: item.doseAdministrationRadiocell,
          doseAdministrationcell: item.doseAdministrationcell,
          doseAdministrationRadioUnknown: item.doseAdministrationRadioUnknown,
          discontinueAgent: item.discontinueAgent,
          reasonForDiscontinuingMedications:
            item.reasonForDiscontinuingMedications,
          adverseEventsDiscontinuationreason:
            item.adverseEventsDiscontinuationreason,
          adverseNeurologicalEventsDiscontinuationreason:
            item.adverseNeurologicalEventsDiscontinuationreason,
        }));

        let bispecificHighestLotListData = [];
        if (bispecificHighestLotList && bispecificHighestLotList.length > 0) {
          bispecificHighestLotListData = bispecificHighestLotList.map((a) => ({
            Cohorttreatmentid: a.cohorttreatmentid,
            // LOT DETAILS
            Lotnumber: a.q262_rbl_A,
            LotStartdateUnk: a.q262_rbl_B === 99,
            LotStartdate:
              (a.q262_rbl_B === 1 && a.q262_date_B != "Invalid Date") ||
              !isStringEmpty(a.q262_autodate_B)
                ? a.q262_date_B
                : null,
            LotEnddateUnk: a.q262_rbl_C === 99,
            LotEnddate:
              (a.q262_rbl_C === 1 && a.q262_date_C != "Invalid Date") ||
              !isStringEmpty(a.q262_autodate_C)
                ? a.q262_date_C
                : null,
            ReceivedLot: a.q262_rbl_E,
            RefractoryTreatment: a.q262_rbl_F,

            // RECEIVED TREATMENT FLAGS
            //a.chk_q262_received_tmt,
            TreatmentReceivedUnknown: a.q262_rb_received_tmt_unk,

            SelectedPrescribedTreatmentList: a.q262_selectedReceivedTmtList.map(
              (x) => ({
                ...x,
                prescribedTreatmentId: x.prescribedTreatmentId,
                prescribedTreatmentOthTxt: x.prescribedTreatmentOthTxt,
              }),
            ),
          }));
        }

        const RRMMModel = {
          Patientid: pid,
          loggedInUserId: GetLoggedInUserID(),
          isValidated: validate,
          medicationTreatmentLists: RRMMData,
          bispecificCartTreatmentAgentList: bispecificAgent,
          bispecificHighestLot: bispecificHighestLotListData,
          IsAdmin: IsAdmin(),
        };
        if (pid > 0) {
          let response =
            await BispecificsCartTreatmentCohortService.SaveBispecificCartTreatmentCohortData(
              RRMMModel,
            );

          if (response.status !== HTTPResponse.OK) {
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else throw response.error;
          } else {
            if (showSucessMsg)
              ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);

            await LoadData(pid);

            //const Data = GetLocalStorageData("CohortTreatment");
            //let cohortTreatmentModelListtndmm = [];
            //if (Data) {
            //    cohortTreatmentModelListtndmm = cohortTreatmentModelListt.filter(c => c.isEligible == true && c.ndmm == true);
            //}
            //navigatePaths.prevPage = cohortTreatmentModelListtndmm.length > 0 ? "/NDMMTreatmentCohort" : "/Comorbidities";
          }

          ToggleLoader(false);
        }
        return true;
      } else {
        ToggleLoader(false);
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      ToggleLoader(false);
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  // Function to get lots above the matching index for a given cohorttreatmentid
  const getLotsAboveMatchingIndex = (row, bispecifictreatment) => {
    return bispecifictreatment
      .filter(
        (item) =>
          item.cohorttreatmentid === row.cohorttreatmentid && item !== row,
      )
      .map((item) => item.lOT);
  };

  const DateInRange = (date, minDate, maxDate) => {
    return dayjs(date).isAfter(minDate) && dayjs(date).isBefore(maxDate);
  };

  const getLatestLastAdminDate = (agents) =>
    agents
      ?.map((a) => parseDate(a.lastDate))
      ?.filter(Boolean)
      ?.sort((a, b) => b - a)[0] || null;

  const getEarliestStartDate = (agents) =>
    agents
      ?.map((a) => parseDate(a.cohortIndexDate))
      ?.filter(Boolean)
      ?.sort((a, b) => a - b)[0] || null;

  const highestLot = Math.max(
    ...bispecificTreatment.map((item) => Number(item.lOT)),
  );

  const ValidateRepeaterData = (bispecifictreatment) => {
    let result = true;
    const sortedLots = [...bispecifictreatment].sort(
      (a, b) => Number(a.lOT) - Number(b.lOT),
    );

    const updatedRepeater = bispecifictreatment.map((row, idx, arr) => {
      let updatedRow = { ...row };

      // ✅ Find CURRENT cohort LOT index
      const sortedIndex = sortedLots.findIndex(
        (item) =>
          Number(item.lOT) === Number(updatedRow.lOT) &&
          item.cohorttreatmentid === updatedRow.cohorttreatmentid,
      );

      let nextLotStartDate = null;

      // ✅ Only check if NEXT LOT exists
      if (sortedIndex !== -1 && sortedIndex < sortedLots.length - 1) {
        const nextLotRow = sortedLots[sortedIndex + 1];

        nextLotStartDate =
          nextLotRow.firstDate === null || nextLotRow.firstDate === ""
            ? null
            : parseDate(nextLotRow.firstDate);
      }
      //Q26b
      if (
        isStringEmpty(row.lOT) ||
        parseInt(row.lOT) < 2 ||
        parseInt(row.lOT) > 40
      ) {
        result = false;
        updatedRow.showColBError = true;
      } else {
        updatedRow.showColBError = false;

        const lotsAbove = getLotsAboveMatchingIndex(row, bispecifictreatment);
        if (lotsAbove.includes(row.lOT)) {
          result = false;
          updatedRow.showColBDuplicateLotError = true;
        } else {
          updatedRow.showColBDuplicateLotError = false;
        }
      }

      if (
        row.cohorttreatmentid != RRMMCohortTreatment.CARVYKTI &&
        row.cohorttreatmentid != RRMMCohortTreatment.ABECMA
      ) {
        //Q26d
        if (
          isStringEmpty(row.lastDate) &&
          isStringEmpty(row.lastDateRadio) &&
          isStringEmpty(row.lastDateUnk)
        ) {
          result = false;
          updatedRow.showColDError = true;
        } else {
          if (row.lastDateRadio === 1 && isStringEmpty(row.lastDate)) {
            result = false;
            updatedRow.showColDError = true;
          } else updatedRow.showColDError = false;
        }

        //Q26e
        if (
          (isStringEmpty(row.noOfAdmission) &&
            isStringEmpty(row.noOfAdmissionRadio) &&
            isStringEmpty(row.noOfAdmissionUnk) &&
            isStringEmpty(row.noOfAdmissionUnkTxt)) ||
          parseInt(row.noOfAdmission) < 1 ||
          parseInt(row.noOfAdmission) > 4000 ||
          (row.noOfAdmissionRadio === 1 && isStringEmpty(row.noOfAdmission))
        ) {
          // if (isStringEmpty(row.noOfAdmission) && isStringEmpty(row.noOfAdmissionRadio) && isStringEmpty(row.noOfAdmissionUnk)) {
          result = false;
          updatedRow.showColEError = true;
        } else {
          if (
            row.noOfAdmissionRadio === 1 &&
            isStringEmpty(row.noOfAdmission)
          ) {
            result = false;
            updatedRow.showColEError = true;
          } else updatedRow.showColEError = false;

          if (
            row.noOfAdmissionUnk === 1 &&
            isStringEmpty(row.noOfAdmissionUnkTxt)
          ) {
            result = false;
            updatedRow.showColEUkTxtError = true;
          } else updatedRow.showColEUkTxtError = false;
        }

        //Q26h
        if (
          isStringEmpty(row.doseAdministrationmg) &&
          isStringEmpty(row.doseAdministrationRadiomg) &&
          isStringEmpty(row.doseAdministrationkg) &&
          isStringEmpty(row.doseAdministrationRadiokg) &&
          isStringEmpty(row.doseAdministrationmgm) &&
          isStringEmpty(row.doseAdministrationRadiomgm) &&
          isStringEmpty(row.doseAdministrationRadioUnknown)
        ) {
          result = false;
          updatedRow.showColHError = true;
        } else {
          if (
            (row.doseAdministrationRadiomg === 1 &&
              (isStringEmpty(row.doseAdministrationmg) ||
                parseFloat(row.doseAdministrationmg) < 0.01 ||
                parseFloat(row.doseAdministrationmg) > 4000)) ||
            (row.doseAdministrationRadiokg === 1 &&
              isStringEmpty(row.doseAdministrationkg)) ||
            parseFloat(row.doseAdministrationkg) < 0.01 ||
            parseFloat(row.doseAdministrationkg) > 4000 ||
            (row.doseAdministrationRadiomgm === 1 &&
              isStringEmpty(row.doseAdministrationmgm)) ||
            parseFloat(row.doseAdministrationmgm) < 0.01 ||
            parseFloat(row.doseAdministrationmgm) > 4000
          ) {
            result = false;
            updatedRow.showColHError = true;
          } else updatedRow.showColHError = false;
        }

        //Q26f
        if (isStringEmpty(row.discontinueAgent)) {
          result = false;
          updatedRow.showColFError = true;
        } else {
          updatedRow.showColFError = false;
        }

        //Q26g
        if (row.discontinueAgent === 1) {
          const isAnySelected = row.reasonForDiscontinuingMedications.some(
            (item) => item.isSelected,
          );
          if (
            isAnySelected ||
            row.reasonForDiscontinuingMedications[0].reasonUnk === true ||
            row.reasonForDiscontinuingMedications[0].reasonUnk === 1
          ) {
            updatedRow.showColGError = false;

            const isReasonOtherSelected =
              row.reasonForDiscontinuingMedications.some(
                (item) =>
                  item.isSelected &&
                  item.reasonName.includes("Other") &&
                  (item.reasonText === null || item.reasonText === ""),
              );
            if (isReasonOtherSelected) {
              result = false;
              updatedRow.showColGOthError = true;
            } else updatedRow.showColGOthError = false;
          } else {
            result = false;
            updatedRow.showColGError = true;
          }
        }

        if (isNewEcrfA) {
          const adverseEventSelected =
            row.reasonForDiscontinuingMedications?.some(
              (r) =>
                r.isSelected &&
                r.reasonName === DiscontinuationReason.AdverseEvent,
            );

          if (adverseEventSelected) {
            const aeList = row.adverseEventsDiscontinuationreason || [];
            const anyAESelected = aeList.some((ae) => ae.isSelected);

            if (!anyAESelected) {
              result = false;
              updatedRow.showAdverseEventError = true;
            } else {
              updatedRow.showAdverseEventError = false;
            }
          } else {
            updatedRow.showAdverseEventError = false;
          }

          const adverseNeurologicalEventSelected =
            row.adverseEventsDiscontinuationreason?.some(
              (r) =>
                r.isSelected &&
                r.reasonName === DiscontinuationReason.NeurologicalEvent,
            );

          if (adverseNeurologicalEventSelected) {
            const aeList =
              row.adverseNeurologicalEventsDiscontinuationreason || [];
            const anyAESelected = aeList.some((ae) => ae.isSelected);

            if (!anyAESelected) {
              result = false;
              updatedRow.showAdverseNeuroEventError = true;
            } else {
              updatedRow.showAdverseNeuroEventError = false;

              const otherSelected =
                row.adverseNeurologicalEventsDiscontinuationreason?.some(
                  (r) =>
                    r.isSelected &&
                    r.reasonName.includes("Other") &&
                    !r.reasonText,
                );
              if (otherSelected) {
                result = false;
                updatedRow.showAdverseNeuroEventOtherTextError = true;
              } else {
                updatedRow.showAdverseNeuroEventOtherTextError = false;
              }
            }
          } else {
            updatedRow.showAdverseNeuroEventError = false;
          }
        }

        if (row.lastDateRadio === 1 && row.lastDate === "Invalid Date") {
          result = false;
          updatedRow.showColD_InvalidDate = true;
        } else if (
          row.lastDateRadio === 1 &&
          row.lastDate &&
          !DateInRange(row.lastDate, dayjs("01-01-1920"), dayjs())
        ) {
          result = false;
          updatedRow.showColD_InvalidDate = true;
        } else {
          updatedRow.showColD_InvalidDate = false;

          const startDt =
            row.firstDate === null || row.firstDate === ""
              ? null
              : parseDate(row.firstDate);
          const endDt =
            row.lastDate === null || row.lastDate === ""
              ? null
              : parseDate(row.lastDate);
          const endOfFollowUpDt =
            row.endOfFollowUpDate === null || row.endOfFollowUpDate === ""
              ? null
              : parseDate(row.endOfFollowUpDate);

          // Validate the parsed dates
          if (row.lastDateUnk !== 1) {
            if (startDt != null && endDt != null) {
              // Check if the last radiotherapy date is within the range
              if (nextLotStartDate != null && endDt > nextLotStartDate) {
                result = false;
                updatedRow.showColD_DateError =
                  row.lastDate === "" || row.lastDate === null ? false : true; //in-valid
              } else {
                if (endOfFollowUpDt != null) {
                  if (startDt <= endDt && endDt <= endOfFollowUpDt) {
                    updatedRow.showColD_LEFDateError = false; //valid
                  } else {
                    result = false;
                    updatedRow.showColD_LEFDateError =
                      row.lastDate === "" || row.lastDate === null
                        ? false
                        : true; //in-valid
                  }
                }
              }
            }
          }

          if (startDt != null && endDt === null && endOfFollowUpDt != null) {
            // Check if the last radiotherapy date is within the range
            if (startDt <= endOfFollowUpDt) {
              updatedRow.showColD_EFDateError = false; //valid
            } else {
              result = false;
              updatedRow.showColD_EFDateError =
                row.firstDate === "" || row.firstDate === null ? false : true; //in-valid
            }
          }

          if (startDt != null && endDt !== null && endOfFollowUpDt == null) {
            // Check if the last radiotherapy date is within the range
            if (startDt <= endDt) {
              updatedRow.showColD_SEFDateError = false; //valid
            } else {
              result = false;
              updatedRow.showColD_SEFDateError = true; //in-valid
            }
          }
        }
      }

      if (
        row.cohorttreatmentid == RRMMCohortTreatment.CARVYKTI ||
        row.cohorttreatmentid == RRMMCohortTreatment.ABECMA
      ) {
        //Q26h

        if (
          isStringEmpty(row.doseAdministrationcell) &&
          isStringEmpty(row.doseAdministrationRadiocell) &&
          isStringEmpty(row.doseAdministrationRadioUnknown)
        ) {
          result = false;
          updatedRow.showColHError = true;
        } else {
          if (
            (row.doseAdministrationRadiocell === 1 &&
              isStringEmpty(row.doseAdministrationcell)) ||
            parseFloat(row.doseAdministrationcell) < 0.01 ||
            parseFloat(row.doseAdministrationcell) > 4000
          ) {
            result = false;
            updatedRow.showColHError = true;
          } else updatedRow.showColHError = false;
        }
      }
      return updatedRow;
    });
    setbispecificTreatment(updatedRepeater);

    if (isNewEcrfA && bispecificAgent?.length > 0) {
      let agentRepeaterValid = ValidateAgentRepeaterData(bispecificAgent);
      if (!agentRepeaterValid) result = false;
    }

    //Q26.2
    if (
      isNewEcrfA &&
      bispecificHighestLotList &&
      bispecificHighestLotList.length > 0
    ) {
      const updatedArr = bispecificHighestLotList.map((row, index) => {
        let q262_B_empty_err = false;
        let q262_B_invalid_date = false;
        let q262_B_before_err = false;
        let q262_B_before_next_lot_err = false;
        let q262_B_beyond_eof_err = false;
        let q262_C_empty_err = false;
        let q262_C_invalid_date = false;
        let q262_C_before_err = false;
        let q262_C_before_next_lot_err = false;
        let q262_C_beyond_eof_err = false;
        let q262_D_empty_err = false;
        let q262_D_txt_empty_err = false;
        let q262_E_empty_err = false;
        let q262_F_empty_err = false;
        let q262_DaraNotSelected_err = false;

        //Q33.1.A
        if (
          row.q262_rbl_B === null &&
          isStringEmpty(row.q262_date_B) &&
          isStringEmpty(row.q262_autodate_B)
        ) {
          q262_B_empty_err = true;
        } else if (row.q262_rbl_B === 1) {
          if (
            isStringEmpty(row.q262_date_B) &&
            isStringEmpty(row.q262_autodate_B)
          ) {
            q262_B_empty_err = true;
          } else if (
            !IsDateValid(row.q262_date_B) &&
            isStringEmpty(row.q262_autodate_B)
          ) {
            q262_B_invalid_date = true;
          } else {
            const nxtLotRowData =
              index > 0 ? bispecificHighestLotList[index + 1] : null;
            const nxtLotStartDt = nxtLotRowData?.q262_date_B;
            const prevLotRowData =
              index > 0 ? bispecificHighestLotList[index - 1] : null;
            const prevLotEndDt = prevLotRowData?.q262_date_C ?? null;
            //Date to be after prev lot end date
            if (!isStringEmpty(prevLotEndDt)) {
              q262_B_before_err = IsDateAfter(prevLotEndDt, row.q262_date_B);
            }
            //Date to be before next lot start date
            if (!isStringEmpty(nxtLotStartDt)) {
              q262_B_before_next_lot_err = IsDateAfter(
                row.q262_date_B,
                nxtLotStartDt,
              );
            }
            //Date selected to be before end of follow up
            if (!isStringEmpty(endOfFollowUpDate)) {
              q262_B_beyond_eof_err = IsDateAfter(
                row.q262_date_B,
                endOfFollowUpDate,
              );
            }
          }
        }

        if (
          row.q262_rbl_C === null &&
          isStringEmpty(row.q262_date_C) &&
          isStringEmpty(row.q262_autodate_C)
        ) {
          q262_C_empty_err = true;
        } else if (row.q262_rbl_C === 1) {
          if (
            isStringEmpty(row.q262_date_C) &&
            isStringEmpty(row.q262_autodate_C)
          ) {
            q262_C_empty_err = true;
          } else if (
            !IsDateValid(row.q262_date_C) &&
            isStringEmpty(row.q262_autodate_C)
          ) {
            q262_C_invalid_date = true;
          } else {
            const nxtLotRowData =
              index > 0 ? bispecificHighestLotList[index + 1] : null;
            const nxtLotStartDt = nxtLotRowData?.q262_date_B;
            const lotStartDt = row?.q262_date_B ?? null;
            //End date >= Start date of same row
            if (!isStringEmpty(lotStartDt)) {
              q262_C_before_err = IsDateAfter(lotStartDt, row.q262_date_C);
            }
            //End date <= Start date of next Lot
            if (!isStringEmpty(nxtLotStartDt)) {
              q262_C_before_next_lot_err = IsDateAfter(
                row.q262_date_C,
                nxtLotStartDt,
              );
            }
            if (!isStringEmpty(endOfFollowUpDate)) {
              q262_C_beyond_eof_err = IsDateAfter(
                row.q262_date_C,
                endOfFollowUpDate,
              );
            }
          }
        }

        if (row.q262_rbl_E === null) {
          q262_E_empty_err = true;
        }
        if (row.q262_rbl_F === null) {
          q262_F_empty_err = true;
        }
        if (
          !row.q262_rb_received_tmt_unk &&
          row.q262_selectedReceivedTmtList.length === 0
        ) {
          q262_D_empty_err = true;
        } else if (row.q262_selectedReceivedTmtList.length > 0) {
          const otherItem = row.q262_selectedReceivedTmtList?.find(
            (t) => t.prescribedTreatmentId === row.prescribedTmtOtherID,
          );

          if (otherItem && !otherItem.prescribedTreatmentOthTxt?.trim()) {
            q262_D_txt_empty_err = true;
          }
        }

        //DR & DRd
        if (row.bindedCohorttreatmentid == 1) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has7or8 = list.some(
            (r) =>
              r.prescribedTreatmentId === 7 || r.prescribedTreatmentId === 8,
          );

          const DaraExist = has2 && has7or8;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        //DVR & DVRd
        if (
          row.bindedCohorttreatmentid == 2 ||
          row.bindedCohorttreatmentid == 3
        ) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has4 = list.some((r) => r.prescribedTreatmentId === 4);
          const has7or8 = list.some(
            (r) =>
              r.prescribedTreatmentId === 7 || r.prescribedTreatmentId === 8,
          );

          const DaraExist = has2 && has4 && has7or8;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        //DKR & DKRd
        if (row.bindedCohorttreatmentid == 4) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has5 = list.some((r) => r.prescribedTreatmentId === 5);
          const has7or8 = list.some(
            (r) =>
              r.prescribedTreatmentId === 7 || r.prescribedTreatmentId === 8,
          );

          const DaraExist = has2 && has5 && has7or8;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        //VR & VRd
        if (
          row.bindedCohorttreatmentid == 5 ||
          row.bindedCohorttreatmentid == 6
        ) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has4 = list.some((r) => r.prescribedTreatmentId === 4);
          const DaraExist = has2 && has4;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        //IsaVR & IsaVRd
        if (
          row.bindedCohorttreatmentid == 7 ||
          row.bindedCohorttreatmentid == 8
        ) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has4 = list.some((r) => r.prescribedTreatmentId === 4);
          const has9 = list.some((r) => r.prescribedTreatmentId === 9);
          const DaraExist = has2 && has4 && has9;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        if (
          q262_B_empty_err ||
          q262_B_invalid_date ||
          q262_C_empty_err ||
          q262_C_invalid_date ||
          q262_DaraNotSelected_err ||
          q262_D_empty_err ||
          q262_D_txt_empty_err ||
          q262_E_empty_err ||
          q262_F_empty_err ||
          q262_B_before_err ||
          q262_B_before_next_lot_err ||
          q262_B_beyond_eof_err ||
          q262_C_before_err ||
          q262_C_before_next_lot_err ||
          q262_C_beyond_eof_err
        ) {
          result = false;
        }

        return {
          ...row,
          q262_B_empty_err,
          q262_B_invalid_date,
          q262_B_before_err,
          q262_B_before_next_lot_err,
          q262_B_beyond_eof_err,
          q262_C_empty_err,
          q262_C_invalid_date,
          q262_C_before_err,
          q262_C_before_next_lot_err,
          q262_C_beyond_eof_err,
          q262_D_empty_err,
          q262_D_txt_empty_err,
          q262_DaraNotSelected_err,
          q262_E_empty_err,
          q262_F_empty_err,
        };
      });
      setBispecificHighestLotList(updatedArr);
    }

    return result;
  };
  const ValidateBispecificCarTEndDateChain = (
    date, // Bispecifics/CAR-T agent end date (main date)
    diagnosisDate,
    cohortType,
  ) => {
    const dx = IsValidDateValue(diagnosisDate) ? diagnosisDate : null;
    const mmDiagnosisDate = intialMMDiagnosisDate
      ? IsValidDateValue(intialMMDiagnosisDate)
      : null;
    const endDate = date ? IsValidDateValue(date) : null;
    const eofDate = endFollowUpDate ? IsValidDateValue(endFollowUpDate) : null;

    // Rule 1: Diagnosis ≤ Initiation
    if (dx && mmDiagnosisDate && IsDateLessThan(dx, intialMMDiagnosisDate)) {
      return false;
    }

    // Rule 2: Initiation mm ≤ End date
    if (
      mmDiagnosisDate &&
      endDate &&
      IsDateLessThan(date, intialMMDiagnosisDate)
    ) {
      return false;
    }

    // Rule 3: End date ≤ End of follow-up
    if (endDate && eofDate && IsDateLessThan(endFollowUpDate, date)) {
      return false;
    }

    // Rule 4: Diagnosis ≤ End date (if initiation missing)
    if (dx && endDate && IsDateLessThan(date, dx)) {
      return false;
    }

    return true;
  };

  const formatDate = (date) => {
    if (!date) return null;
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  const ValidateAgentRepeaterData = (bispecificAgent) => {
    let result = true;

    // Loop through each cohort
    const updatedCohortData = bispecificAgent.map((cohort) => {
      const updatedCohort = { ...cohort };
      if (!cohort.agentLists || cohort.agentLists.length === 0)
        return updatedCohort;

      const sortedLots = [...bispecificAgent].sort(
        (a, b) => Number(a.lot) - Number(b.lot),
      );

      // ✅ Find CURRENT cohort LOT index
      const sortedIndex = sortedLots.findIndex(
        (item) => Number(item.lot) === Number(cohort.lot),
      );

      let nextLotStartDate = null;

      // ✅ Only check if NEXT LOT exists
      if (sortedIndex !== -1 && sortedIndex < bispecificAgent.length - 1) {
        const nextLotRow = sortedLots[sortedIndex + 1];

        let earliestAgentNextLotStartDate = getEarliestStartDate(
          nextLotRow.agentLists,
        );

        let s12DateLotStartDate = bispecificTreatment.find(
          (bt) => bt.cohorttreatmentid === nextLotRow.cohortTreatmentId,
        )?.cohortIndexDate;

        // Convert string (MM/DD/YYYY) to Date
        let s12Date = s12DateLotStartDate
          ? new Date(s12DateLotStartDate)
          : null;

        // Ensure both are Date objects
        let agentDate = earliestAgentNextLotStartDate
          ? new Date(earliestAgentNextLotStartDate)
          : null;

        let nextLotStartDateValue = null;

        if (agentDate && s12Date) {
          nextLotStartDateValue = agentDate < s12Date ? agentDate : s12Date;
        } else {
          nextLotStartDateValue = agentDate || s12Date; // whichever exists
        }

        // Format to MM/DD/YYYY

        nextLotStartDate = formatDate(nextLotStartDateValue);
      }

      // ✅ Latest LAST admin date across agents of CURRENT LOT
      //const latestLastAdminDate = getLatestLastAdminDate(cohort.agentLists);

      // Loop through each agent in the cohort
      const updatedAgents = cohort.agentLists.map((agent) => {
        const updatedAgent = { ...agent };
        // ---- Validate Last Administration Date ----
        if (
          !agent.lastDate &&
          agent.lastDateRadio !== 0 &&
          agent.lastDateUnk !== 1
        ) {
          result = false;
          updatedAgent.showColDError = true;
        } else {
          if (
            agent.lastDate &&
            !ValidateBispecificCarTEndDateChain(
              agent.lastDate,
              agent.cohortIndexDate,
              agent.cohortTreatmentId,
            )
          ) {
            result = false;
            updatedAgent.agentDateRangeError = true;
          } else {
            updatedAgent.agentDateRangeError = false;

            if (agent.lastDate && nextLotStartDate) {
              if (IsDateLessThan(nextLotStartDate, agent.lastDate)) {
                result = false;
                updatedAgent.agentDateError = true;
              } else {
                updatedAgent.agentDateError = false;
              }
            } else {
              updatedAgent.agentDateError = false;
            }
          }

          updatedAgent.showColDError = false;
        }

        // ---- Validate Number of Administrations ----
        if (
          (!agent.noOfAdmission &&
            !agent.noOfAdmissionRadio &&
            !agent.noOfAdmissionUnk &&
            !agent.noOfAdmissionUnkTxt) ||
          (agent.noOfAdmissionRadio &&
            (parseInt(agent.noOfAdmission ?? 0) <= 0 ||
              parseInt(agent.noOfAdmission ?? 0) > 4000))
        ) {
          result = false;
          updatedAgent.showColEError = true;
        } else if (agent.noOfAdmissionRadio === 1 && !agent.noOfAdmission) {
          result = false;
          updatedAgent.showColEError = true;
        } else {
          updatedAgent.showColEError = false;
        }

        if (agent.noOfAdmissionUnk === 1 && !agent.noOfAdmissionUnkTxt) {
          result = false;
          updatedAgent.showColEUkTxtError = true;
        } else {
          updatedAgent.showColEUkTxtError = false;
        }
        // ---- Validate Dose ----
        if (
          !agent.doseAdministrationmg &&
          agent.doseAdministrationmg != "" &&
          !agent.doseAdministrationkg &&
          agent.doseAdministrationkg != "" &&
          !agent.doseAdministrationmgm &&
          agent.doseAdministrationmgm != "" &&
          !agent.doseAdministrationRadioUnknown
        ) {
          result = false;
          updatedAgent.showColHError = true;
        } else if (
          (agent.doseAdministrationRadiomg === 1 &&
            (isStringEmpty(agent.doseAdministrationmg) ||
              parseFloat(agent.doseAdministrationmg) <= 0.0 ||
              parseFloat(agent.doseAdministrationmg) > 4000)) ||
          (agent.doseAdministrationRadiokg === 1 &&
            (isStringEmpty(agent.doseAdministrationkg) ||
              parseFloat(agent.doseAdministrationkg) <= 0.0 ||
              parseFloat(agent.doseAdministrationkg) > 4000)) ||
          (agent.doseAdministrationRadiomgm === 1 &&
            (isStringEmpty(agent.doseAdministrationmgm) ||
              parseFloat(agent.doseAdministrationmgm) <= 0.0 ||
              parseFloat(agent.doseAdministrationmgm) > 4000))
        ) {
          result = false;
          updatedAgent.showColHError = true;
        } else {
          updatedAgent.showColHError = false;
        }

        // ---- Validate Discontinue Agent ----
        if (agent.discontinueAgent == null) {
          result = false;
          updatedAgent.showColFError = true;
        } else {
          updatedAgent.showColFError = false;
        }

        // ---- Validate Reason for Discontinuing ----
        if (agent.discontinueAgent === 1) {
          const anySelected = agent.reasonForDiscontinuingMedications?.some(
            (r) => r.isSelected,
          );
          if (
            !anySelected &&
            !agent.reasonForDiscontinuingMedications[0].reasonUnk
          ) {
            result = false;
            updatedAgent.showColGError = true;
          } else {
            updatedAgent.showColGError = false;

            const otherSelected = agent.reasonForDiscontinuingMedications?.some(
              (r) =>
                r.isSelected && r.reasonName.includes("Other") && !r.reasonText,
            );
            if (otherSelected) {
              result = false;
              updatedAgent.showColGOthError = true;
            } else {
              updatedAgent.showColGOthError = false;
            }
          }

          if (isNewEcrfA) {
            const adverseEventSelected =
              agent.reasonForDiscontinuingMedications?.some(
                (r) =>
                  r.isSelected &&
                  r.reasonName === DiscontinuationReason.AdverseEvent,
              );

            if (adverseEventSelected) {
              const aeList = agent.adverseEventsDiscontinuationreason || [];
              const anyAESelected = aeList.some((ae) => ae.isSelected);

              if (!anyAESelected) {
                result = false;
                updatedAgent.showAdverseEventError = true;
              } else {
                updatedAgent.showAdverseEventError = false;
              }
            } else {
              updatedAgent.showAdverseEventError = false;
            }

            const adverseNeurologicalEventSelected =
              agent.adverseEventsDiscontinuationreason?.some(
                (r) =>
                  r.isSelected &&
                  r.reasonName === DiscontinuationReason.NeurologicalEvent,
              );

            if (adverseNeurologicalEventSelected) {
              const aeList =
                agent.adverseNeurologicalEventsDiscontinuationreason || [];
              const anyAESelected = aeList.some((ae) => ae.isSelected);

              if (!anyAESelected) {
                result = false;
                updatedAgent.showAdverseNeuroEventError = true;
              } else {
                updatedAgent.showAdverseNeuroEventError = false;

                const otherSelected =
                  agent.adverseNeurologicalEventsDiscontinuationreason?.some(
                    (r) =>
                      r.isSelected &&
                      r.reasonName.includes("Other") &&
                      !r.reasonText,
                  );
                if (otherSelected) {
                  result = false;
                  updatedAgent.showAdverseNeuroEventOtherTextError = true;
                } else {
                  updatedAgent.showAdverseNeuroEventOtherTextError = false;
                }
              }
            } else {
              updatedAgent.showAdverseNeuroEventError = false;
            }
          }
        }

        return updatedAgent;
      });

      updatedCohort.agentLists = updatedAgents;
      return updatedCohort;
    });

    setbispecificAgent(updatedCohortData);
    return result;
  };

  function parseDate(dateString) {
    if (!dateString || typeof dateString !== "string" || !dateString.trim()) {
      return undefined; // or null, depending on what your app expects
    }

    const [month, day, year] = dateString.split("/");

    if (!month || !day || !year) {
      return undefined;
    }

    return new Date(year, month - 1, day);
  }

  const ShowAlertBox = async () => {
    await ShowActionPopUp(
      "Alert", //title
      CommonError_Msgs.DateChangeAlert, //message
      "Ok", //Confirm button text
      true,
    );
  };

  const Handle262FieldChange = (e) => {
    const { name, id, value } = e.target;
    const value_int = Number(value);

    let updatedArray = [...bispecificHighestLotList];

    if (isNewEcrfA) {
      switch (name) {
        //Q26.2
        case "q262_rbl_B" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_date_B: null,
              q262_rbl_B: value_int,
              q262_B_unk_err: value_int === 99 ? true : false,
              q262_B_empty_err: false,
              q262_B_invalid_date: false,
              q262_B_before_err: false,
              q262_B_before_next_lot_err: false,
              q262_B_beyond_eof_err: false,
            };
          }
          break;
        case "q262_rbl_C" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_date_C: null,
              q262_rbl_C: value_int,
              q262_C_unk_err: value_int === 99 ? true : false,
              q262_C_empty_err: false,
              q262_C_invalid_date: false,
              q262_C_before_err: false,
              q262_C_before_next_lot_err: false,
              q262_C_beyond_eof_err: false,
            };
          }
          break;
        case "q262_rb_received_tmt_unk" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_rb_received_tmt_unk:
                !updatedArray[id].q262_rb_received_tmt_unk,
              q262_selectedReceivedTmtList: [],
              q262_D_empty_err: false,
              q262_D_txt_empty_err: false,
              q262_DaraNotSelected_err: false,
            };
          }
          break;
        case "chk_q262_received_tmt" + id:
          {
            const index = id.split("_")[0];
            const tmtID = id.split("_").pop(); // Extract the selected received tmt id
            const selTmtList = updatedArray[index].q262_selectedReceivedTmtList;
            const tmtIndex = selTmtList.findIndex(
              (item) => item.prescribedTreatmentId === Number(tmtID),
            );

            if (tmtIndex >= 0) {
              // Checkbox unselect
              selTmtList.splice(tmtIndex, 1);
            } else {
              // Checkbox select
              selTmtList.push({ prescribedTreatmentId: Number(tmtID) });
            }
            updatedArray[index] = {
              ...updatedArray[index],
              q262_selectedReceivedTmtList: selTmtList,
              q262_rb_received_tmt_unk: false,

              q262_D_empty_err: false,
              q262_D_txt_empty_err: false,
              q262_DaraNotSelected_err: false,
            };
          }
          break;
        case "q262_txt_received_tmt_oth":
          {
            const index = id.split("_")[0];
            const tmtID = id.split("_").pop();
            const selTmtList = updatedArray[index].q262_selectedReceivedTmtList;

            // Check if the item with the same prescribedTreatmentId already exists
            const existingItemIndex = selTmtList.findIndex(
              (item) => item.prescribedTreatmentId === Number(tmtID),
            );

            if (existingItemIndex >= 0) {
              selTmtList[existingItemIndex] = {
                ...selTmtList[existingItemIndex],
                prescribedTreatmentOthTxt: value,
              };
            } else {
              selTmtList.push({
                prescribedTreatmentId: Number(tmtID),
                prescribedTreatmentOthTxt: value,
              });
            }

            updatedArray[index] = {
              ...updatedArray[index],
              q262_selectedReceivedTmtList: selTmtList,
              q262_rb_received_tmt_unk: false,

              q262_D_empty_err: false,
              q262_D_txt_empty_err: false,
              q262_DaraNotSelected_err: false,
            };
          }
          break;
        case "q262_rbl_E" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_rbl_E: value_int,
              q262_E_empty_err: false,
            };
          }
          break;
        case "q262_rbl_F" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_rbl_F: value_int,
              q262_F_empty_err: false,
            };
          }
          break;
        default:
          break;
      }
    }
    setBispecificHighestLotList(updatedArray);
  };

  const Handle262DateChange = (name, date, id) => {
    let updatedArray = [...bispecificHighestLotList];

    if (isNewEcrfA) {
      switch (name) {
        case "q262_date_B" + id:
          {
            updatedArray[id].q262_date_B = date;
            updatedArray[id].q262_rbl_B = 1;

            updatedArray[id].q262_B_empty_err = false;
            updatedArray[id].q262_B_unk_err = false;
            updatedArray[id].q262_B_invalid_date = false;
            updatedArray[id].q262_B_before_err = false;
            updatedArray[id].q262_B_before_next_lot_err = false;
            updatedArray[id].q262_B_beyond_eof_err = false;
          }
          break;
        case "q262_date_C" + id:
          {
            updatedArray[id].q262_date_C = date;
            updatedArray[id].q262_rbl_C = 1;

            updatedArray[id].q262_C_empty_err = false;
            updatedArray[id].q262_C_unk_err = false;
            updatedArray[id].q262_C_invalid_date = false;
            updatedArray[id].q262_C_before_err = false;
            updatedArray[id].q262_C_before_next_lot_err = false;
            updatedArray[id].q262_C_beyond_eof_err = false;
          }
          break;

        default:
          break;
      }
    }
    setBispecificHighestLotList(updatedArray);
  };

  return (
    <>
      <div className="survey-section-content">
        <div className="survey-section-content-header">
          <h4>BISPECIFIC/CAR-T TREATMENT COHORT</h4>
        </div>
        {showTopErrMsg && (
          <div className="clean-error ">
            <ErrorField
              show={showTopErrMsg}
              message={CommonError_Msgs.Hard_Empty}
            />
          </div>
        )}
        <div className="survey-question-section">
          <div className="survey-question-content calender-datefix-survey">
            <div className="question-answer">
              {/* Q26 */}
              <div className="question-bot-sapce">
                <div className="question question-weight">
                  <span>Q26.</span>
                  <span className="quest-text-pad">
                    Describe the prescribed dosing information for each
                    bispecific and/or CAR-T therapy that the patient has
                    received. <br />
                    <b>Please note the following: </b>
                    <br />
                    (a) Date of first administration of Bispecific/CAR-T
                    treatment must be no later than the date of last
                    administration of the same treatment
                    <br />
                    (b) None of the dates of first administration or last
                    administration should be later than the end of follow up on{" "}
                    <span style={{ color: PageDesignConstants.fontColor }}>
                      {endFollowUpDate ? endFollowUpDate : "[end of follow up]"}
                    </span>
                    .
                    <br />
                    (c) If a medication agent’s discontinuation status is “No,
                    medication ongoing at time of last encounter” below, please
                    enter the “Date of the last administration” as the last
                    known administration date on or prior to the patient’s last
                    encounter date on{" "}
                    <span style={{ color: PageDesignConstants.fontColor }}>
                      {lastEncounterDate
                        ? lastEncounterDate
                        : "[date of last encounter]"}
                    </span>
                    .{" "}
                  </span>
                </div>
              </div>
            </div>

            <div className="question-answer">
              <div className="question-bot-sapce">
                <div className=" double-dig-answer">
                  <div className="" style={{ overflowX: "auto" }}>
                    <table
                      style={{
                        border: "1px solid black",
                        borderCollapse: "collapse",
                        width: "100%",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            Medication
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                              minWidth: "135px",
                            }}
                          >
                            {" "}
                            <span
                              data-tooltip-id="encounterTip"
                              className="modal-popup"
                              onClick={() => setShowHideHyperlinkModal(true)}
                            >
                              Line Of Therapy
                            </span>
                            {showHideHyperlinkModal && (
                              <InfoPopUp
                                description={hyperlinkTextLineOfTherapy}
                                OkClick={() => setShowHideHyperlinkModal(false)}
                              />
                            )}{" "}
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            Date of first administration
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            Date of last administration
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                              minWidth: "195px",
                            }}
                          >
                            Number of administrations
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                              minWidth: "305px",
                            }}
                          >
                            Dose at first administration
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                              minWidth: "250px",
                            }}
                          >
                            Did patient discontinue agent?
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                              minWidth: "300px",
                            }}
                          >
                            Reason for discontinuing
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Populate static rows */}
                        {bispecificTreatment.length > 0 &&
                          bispecificTreatment?.map((data, idx) => (
                            <tr key={idx}>
                              <td
                                style={{
                                  border: "1px solid black",
                                  alignContent: "start",
                                  textAlign: "center",
                                  padding: "8px",
                                }}
                              >
                                {}
                                <div>
                                  {data.cohortTreatmentName}
                                  {data.supscripttext == null ? (
                                    ""
                                  ) : (
                                    <>
                                      <sup className="supscript">
                                        {data.supscripttext.slice(0, 2)}
                                      </sup>
                                      {data.supscripttext.slice(2)}
                                    </>
                                  )}
                                </div>
                              </td>

                              <td
                                style={{
                                  border: "1px solid black",
                                  alignContent: "flex-start",
                                  textAlign: "center",
                                  padding: "10px",
                                }}
                              >
                                <div className="">
                                  <label
                                    htmlFor={`q26b_${data.cohortTreatmentName}_lottxt_${idx}`}
                                  >
                                    <span className="">
                                      <input
                                        className="input-dash"
                                        id={`q26b_${data.cohortTreatmentName}_lottxt_${idx}`}
                                        name={`q26b_${data.cohortTreatmentName}_lottxt_${idx}`}
                                        type="text"
                                        value={data.lOT}
                                        min={2}
                                        max={40}
                                        //maxLength={2}
                                        onKeyDown={(e) => {
                                          // Prevent entering '.', 'e', '+', '-', and any non-numeric characters
                                          if (
                                            [".", "e", "+", "-", "E"].includes(
                                              e.key,
                                            ) ||
                                            (e.key.length === 1 &&
                                              !/[0-9]/.test(e.key))
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                      />
                                    </span>
                                  </label>
                                  {/*<label><span className="" style={{ textAlign: 'start' }}>(Range: 1 to 40)</span></label>*/}
                                </div>

                                <ErrorField
                                  style={{ padding: "0px" }}
                                  show={bispecificTreatment[idx].showColBError}
                                  message={
                                    BispecificCartTreatmentCohort_Msgs.q26b
                                  }
                                />
                                <ErrorField
                                  style={{ padding: "0px" }}
                                  show={
                                    bispecificTreatment[idx]
                                      .showColBDuplicateLotError
                                  }
                                  message={
                                    BispecificCartTreatmentCohort_Msgs.q26duplicateb
                                  }
                                />
                              </td>

                              <td
                                style={{
                                  border: "1px solid black",
                                  alignContent: "start",
                                  textAlign: "center",
                                  padding: "8px",
                                }}
                              >
                                {}
                                <div
                                  className="radio-text-padding"
                                  style={{ display: "flex" }}
                                >
                                  <div>{data.cohortIndexDate}</div>
                                </div>
                              </td>

                              {bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.CARVYKTI &&
                              bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.ABECMA ? (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",
                                    textAlign: "center",
                                    padding: "8px",
                                  }}
                                >
                                  <div className="">
                                    <div
                                      className="option-without-input"
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        id={`q26d_LRadio_${data.cohortTreatmentName}_${idx}`}
                                        name={`q26d_LRadio_${data.cohortTreatmentName}_${idx}`}
                                        style={{ marginTop: "6px" }}
                                        value={1}
                                        checked={data.lastDateRadio === 1}
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                      />
                                      <span
                                        className="radio-text-padding datepicker-dependence calender-datefix"
                                        style={{ paddingLeft: "5px" }}
                                      >
                                        {/*<DateControl*/}
                                        {/*    ctrlId={`q26d_LDate_${idx}`}*/}
                                        {/*    HandleDateChange={HandleDateChange}*/}
                                        {/*    defDate={data.lastDate}*/}
                                        {/*    optionId={1}*/}
                                        {/*    date={data.lastDate}*/}
                                        {/*/>*/}
                                        <DatePickerComponent
                                          ctrlId={`q26d_LDate_${idx}`}
                                          HandleDateChange={HandleDateChange}
                                          minDate={dayjs("01-01-1920")}
                                          maxDate={dayjs()}
                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                          date={data.lastDate}
                                        />
                                      </span>
                                    </div>
                                    <div
                                      className="option-without-input"
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                      }}
                                    >
                                      <label
                                        style={{
                                          textAlign: "start",
                                          display: "flex",
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          id={`q26d_${data.cohortTreatmentName}_LUnk_${idx}`}
                                          name={`q26d_${data.cohortTreatmentName}_LUnk_${idx}`}
                                          style={{ marginTop: "6px" }}
                                          value={1}
                                          checked={data.lastDateUnk === 1}
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                        />
                                        <span className="radio-text-padding">
                                          Date of last administration unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx].showColDError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26d
                                    }
                                  />

                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx]
                                        .showColD_SEFDateError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26d_sef
                                    }
                                  />
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx]
                                        .showColD_LEFDateError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26d_lef
                                    }
                                  />
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx]
                                        .showColD_DateError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26d_date
                                    }
                                  />
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx]
                                        .showColD_EFDateError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26d_sef
                                    }
                                  />
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx]
                                        .showColD_InvalidDate
                                    }
                                    message={CommonError_Msgs.InvalidDate}
                                  />
                                </td>
                              ) : (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",
                                    textAlign: "center",
                                    padding: "8px",
                                    textAlign: "start",
                                  }}
                                >
                                  <span
                                    style={{ textAlign: "center" }}
                                    className="not-applicable"
                                  >
                                    <b>Not applicable</b>
                                  </span>
                                </td>
                              )}
                              {bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.CARVYKTI &&
                              bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.ABECMA ? (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",

                                    padding: "8px",
                                  }}
                                >
                                  <div
                                    className="option-fbox"
                                    style={{ width: "216px" }}
                                  >
                                    <label
                                      htmlFor={`q26e_${data.cohortTreatmentName}_Noa_${idx}`}
                                    >
                                      <input
                                        type="radio"
                                        id={`q26e_${data.cohortTreatmentName}_Noa_${idx}`}
                                        name={`q26e_${data.cohortTreatmentName}_Noa_${idx}`}
                                        value={1}
                                        checked={data.noOfAdmissionRadio === 1}
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                      />
                                    </label>
                                    <label
                                      htmlFor={`q26e_${data.cohortTreatmentName}_Noatxt_${idx}`}
                                    >
                                      <span className="radio-text-padding">
                                        <input
                                          className="input-dash"
                                          id={`q26e_${data.cohortTreatmentName}_Noatxt_${idx}`}
                                          name={`q26e_${data.cohortTreatmentName}_Noatxt_${idx}`}
                                          type="text"
                                          value={data.noOfAdmission}
                                          min={1}
                                          max={4000}
                                          // maxLength={3}
                                          onKeyDown={(e) => {
                                            // Prevent entering '.', 'e', '+', '-', and any non-numeric characters
                                            if (
                                              [
                                                ".",
                                                "e",
                                                "+",
                                                "-",
                                                "E",
                                              ].includes(e.key) ||
                                              (e.key.length === 1 &&
                                                !/[0-9]/.test(e.key))
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                        />
                                      </span>
                                    </label>
                                    {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                  </div>
                                  <div
                                    className="option-without-input"
                                    style={{ width: "216px" }}
                                  >
                                    <label className="option-fbox">
                                      <input
                                        type="radio"
                                        id={`q26e_${data.cohortTreatmentName}_NoaUnk_${idx}`}
                                        name={`q26e_${data.cohortTreatmentName}_NoaUnk_${idx}`}
                                        value={1}
                                        checked={data.noOfAdmissionUnk === 1}
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                      />
                                      <span
                                        className="radio-text-padding"
                                        style={{ textAlign: "left" }}
                                      >
                                        Unknown, please specify dosing schedule:
                                        <textarea
                                          className="input-dash"
                                          id={`q26e_${data.cohortTreatmentName}_NoaUnktxt_${idx}`}
                                          name={`q26e_${data.cohortTreatmentName}_NoaUnktxt_${idx}`}
                                          type="text"
                                          value={data.noOfAdmissionUnkTxt}
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                        />
                                      </span>
                                    </label>
                                  </div>
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx].showColEError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26e
                                    }
                                  />
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx]
                                        .showColEUkTxtError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26eTxt
                                    }
                                  />
                                </td>
                              ) : (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",
                                    textAlign: "center",
                                    padding: "8px",
                                    textAlign: "start",
                                  }}
                                >
                                  <span
                                    style={{ textAlign: "center" }}
                                    className="not-applicable"
                                  >
                                    <b>Not applicable</b>
                                  </span>
                                </td>
                              )}

                              {bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.CARVYKTI &&
                              bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.ABECMA ? (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",

                                    padding: "8px",
                                  }}
                                >
                                  <div className="option-fbox">
                                    <label
                                      htmlFor={`q26h1_${data.cohortTreatmentName}_mg_${idx}`}
                                    >
                                      <input
                                        type="radio"
                                        id={`q26h1_${data.cohortTreatmentName}_mg_${idx}`}
                                        name={`q26h1_${data.cohortTreatmentName}_mg_${idx}`}
                                        value={1}
                                        checked={
                                          data.doseAdministrationRadiomg === 1
                                        }
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                      />
                                    </label>
                                    <label
                                      htmlFor={`q26h1_${data.cohortTreatmentName}_mgtxt_${idx}`}
                                    >
                                      <span className="radio-text-padding">
                                        <input
                                          className="input-dash-custom"
                                          id={`q26h1_${data.cohortTreatmentName}_mgtxt_${idx}`}
                                          name={`q26h1_${data.cohortTreatmentName}_mgtxt_${idx}`}
                                          type="text"
                                          value={data.doseAdministrationmg}
                                          min={0}
                                          max={4000}
                                          // maxLength={3}
                                          onKeyDown={(e) => {
                                            // Allow backspace, arrow keys, delete, and tab
                                            if (
                                              [
                                                "Backspace",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Delete",
                                                "Tab",
                                              ].includes(e.key)
                                            ) {
                                              return;
                                            }
                                            // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                            if (
                                              !/[0-9.]/.test(e.key) ||
                                              (e.key === "." &&
                                                e.target.value.includes("."))
                                            ) {
                                              e.preventDefault();
                                              return;
                                            }
                                            const value = e.target.value;
                                            const selectionStart =
                                              e.target.selectionStart;
                                            const newValue =
                                              value.slice(0, selectionStart) +
                                              e.key +
                                              value.slice(
                                                e.target.selectionEnd,
                                              );
                                            // Prevent '.' as the first character
                                            if (e.key === "." && value === "") {
                                              e.preventDefault();
                                              return;
                                            }
                                            // Allow only one digit after decimal point
                                            if (
                                              newValue.includes(".") &&
                                              newValue.split(".")[1].length > 2
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                        />{" "}
                                        &nbsp; mg
                                      </span>
                                    </label>
                                    {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                  </div>
                                  <br />
                                  <div className="option-fbox">
                                    <label
                                      htmlFor={`q26h2_${data.cohortTreatmentName}_kg_${idx}`}
                                    >
                                      <input
                                        type="radio"
                                        id={`q26h2_${data.cohortTreatmentName}_kg_${idx}`}
                                        name={`q26h2_${data.cohortTreatmentName}_kg_${idx}`}
                                        value={1}
                                        checked={
                                          data.doseAdministrationRadiokg === 1
                                        }
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                      />
                                    </label>
                                    <label
                                      htmlFor={`q26h2_${data.cohortTreatmentName}_kgtxt_${idx}`}
                                    >
                                      <span className="radio-text-padding">
                                        <input
                                          className="input-dash-custom"
                                          id={`q26h2_${data.cohortTreatmentName}_kgtxt_${idx}`}
                                          name={`q26h2_${data.cohortTreatmentName}_kgtxt_${idx}`}
                                          type="text"
                                          value={data.doseAdministrationkg}
                                          min={0}
                                          max={4000}
                                          // maxLength={3}
                                          onKeyDown={(e) => {
                                            // Allow backspace, arrow keys, delete, and tab
                                            if (
                                              [
                                                "Backspace",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Delete",
                                                "Tab",
                                              ].includes(e.key)
                                            ) {
                                              return;
                                            }
                                            // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                            if (
                                              !/[0-9.]/.test(e.key) ||
                                              (e.key === "." &&
                                                e.target.value.includes("."))
                                            ) {
                                              e.preventDefault();
                                              return;
                                            }
                                            const value = e.target.value;
                                            const selectionStart =
                                              e.target.selectionStart;
                                            const newValue =
                                              value.slice(0, selectionStart) +
                                              e.key +
                                              value.slice(
                                                e.target.selectionEnd,
                                              );
                                            // Prevent '.' as the first character
                                            if (e.key === "." && value === "") {
                                              e.preventDefault();
                                              return;
                                            }
                                            // Allow only one digit after decimal point
                                            if (
                                              newValue.includes(".") &&
                                              newValue.split(".")[1].length > 2
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                        />
                                      </span>{" "}
                                      &nbsp; mg/kg
                                    </label>
                                    {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                  </div>
                                  <br />
                                  <div className="option-fbox">
                                    <label
                                      htmlFor={`q26h3_${data.cohortTreatmentName}_m_${idx}`}
                                    >
                                      <input
                                        type="radio"
                                        id={`q26h3_${data.cohortTreatmentName}_m_${idx}`}
                                        name={`q26h3_${data.cohortTreatmentName}_m_${idx}`}
                                        value={1}
                                        checked={
                                          data.doseAdministrationRadiomgm === 1
                                        }
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                      />
                                    </label>
                                    <label
                                      htmlFor={`q26h3_${data.cohortTreatmentName}_mtxt_${idx}`}
                                    >
                                      <span className="radio-text-padding">
                                        <input
                                          className="input-dash-custom"
                                          id={`q26h3_${data.cohortTreatmentName}_mtxt_${idx}`}
                                          name={`q26h3_${data.cohortTreatmentName}_mtxt_${idx}`}
                                          type="text"
                                          value={data.doseAdministrationmgm}
                                          min={0}
                                          max={4000}
                                          // maxLength={3}
                                          onKeyDown={(e) => {
                                            // Allow backspace, arrow keys, delete, and tab
                                            if (
                                              [
                                                "Backspace",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Delete",
                                                "Tab",
                                              ].includes(e.key)
                                            ) {
                                              return;
                                            }
                                            // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                            if (
                                              !/[0-9.]/.test(e.key) ||
                                              (e.key === "." &&
                                                e.target.value.includes("."))
                                            ) {
                                              e.preventDefault();
                                              return;
                                            }
                                            const value = e.target.value;
                                            const selectionStart =
                                              e.target.selectionStart;
                                            const newValue =
                                              value.slice(0, selectionStart) +
                                              e.key +
                                              value.slice(
                                                e.target.selectionEnd,
                                              );
                                            // Prevent '.' as the first character
                                            if (e.key === "." && value === "") {
                                              e.preventDefault();
                                              return;
                                            }
                                            // Allow only one digit after decimal point
                                            if (
                                              newValue.includes(".") &&
                                              newValue.split(".")[1].length > 2
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                        />
                                      </span>{" "}
                                      &nbsp; mg/m<sup>2</sup>
                                    </label>
                                    {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                  </div>
                                  <br />

                                  <div className="">
                                    <div className="option-without-input">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id={`q26h4_${data.cohortTreatmentName}_doseUnk_${idx}`}
                                          name={`q26h4_${data.cohortTreatmentName}_doseUnk_${idx}`}
                                          value={99}
                                          checked={
                                            data.doseAdministrationRadioUnknown ===
                                            99
                                          }
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                        />

                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>

                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx].showColHError &&
                                      bispecificTreatment[idx]
                                        .cohorttreatmentid !=
                                        RRMMCohortTreatment.CARVYKTI &&
                                      bispecificTreatment[idx]
                                        .cohorttreatmentid !=
                                        RRMMCohortTreatment.ABECMA
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26h
                                    }
                                  />
                                </td>
                              ) : (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",

                                    padding: "8px",
                                  }}
                                >
                                  <div className="option-fbox">
                                    <label
                                      htmlFor={`q26h4_${data.cohortTreatmentName}_cell_${idx}`}
                                    >
                                      <input
                                        type="radio"
                                        id={`q26h4_${data.cohortTreatmentName}_cell_${idx}`}
                                        name={`q26h4_${data.cohortTreatmentName}_cell_${idx}`}
                                        value={1}
                                        checked={
                                          data.doseAdministrationRadiocell === 1
                                        }
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                      />
                                    </label>
                                    <label
                                      htmlFor={`q26h4_${data.cohortTreatmentName}_celltxt_${idx}`}
                                    >
                                      <span className="radio-text-padding">
                                        <input
                                          className="input-dash-custom"
                                          id={`q26h4_${data.cohortTreatmentName}_celltxt_${idx}`}
                                          name={`q26h4_${data.cohortTreatmentName}_celltxt_${idx}`}
                                          type="text"
                                          value={data.doseAdministrationcell}
                                          min={0}
                                          max={4000}
                                          // maxLength={3}
                                          onKeyDown={(e) => {
                                            // Allow backspace, arrow keys, delete, and tab
                                            if (
                                              [
                                                "Backspace",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Delete",
                                                "Tab",
                                              ].includes(e.key)
                                            ) {
                                              return;
                                            }
                                            // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                            if (
                                              !/[0-9.]/.test(e.key) ||
                                              (e.key === "." &&
                                                e.target.value.includes("."))
                                            ) {
                                              e.preventDefault();
                                              return;
                                            }
                                            const value = e.target.value;
                                            const selectionStart =
                                              e.target.selectionStart;
                                            const newValue =
                                              value.slice(0, selectionStart) +
                                              e.key +
                                              value.slice(
                                                e.target.selectionEnd,
                                              );
                                            // Prevent '.' as the first character
                                            if (e.key === "." && value === "") {
                                              e.preventDefault();
                                              return;
                                            }
                                            // Allow only one digit after decimal point
                                            if (
                                              newValue.includes(".") &&
                                              newValue.split(".")[1].length > 2
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                        />
                                      </span>{" "}
                                      &nbsp; x 10<sup>6</sup>&nbsp;cells
                                      {bispecificTreatment[idx]
                                        .cohorttreatmentid ==
                                        RRMMCohortTreatment.CARVYKTI && (
                                        <>/kg</>
                                      )}
                                    </label>
                                    {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                  </div>
                                  <br />
                                  <div className="">
                                    <div className="option-without-input">
                                      <label className="option-fbox">
                                        <input
                                          type="radio"
                                          id={`q26h4_${data.cohortTreatmentName}_doseUnk_${idx}`}
                                          name={`q26h4_${data.cohortTreatmentName}_doseUnk_${idx}`}
                                          value={99}
                                          checked={
                                            data.doseAdministrationRadioUnknown ===
                                            99
                                          }
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                        />

                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>

                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx].showColHError &&
                                      (bispecificTreatment[idx]
                                        .cohorttreatmentid ==
                                        RRMMCohortTreatment.CARVYKTI ||
                                        bispecificTreatment[idx]
                                          .cohorttreatmentid ==
                                          RRMMCohortTreatment.ABECMA)
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26h
                                    }
                                  />
                                </td>
                              )}

                              {bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.CARVYKTI &&
                              bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.ABECMA ? (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",
                                    padding: "8px",
                                  }}
                                >
                                  <div className="">
                                    <div
                                      className="option-without-input"
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        id={`q26f_${data.cohortTreatmentName}_PdaYes_${idx}`}
                                        name={`q26f_${data.cohortTreatmentName}_PdaYes_${idx}`}
                                        value={1}
                                        checked={data.discontinueAgent === 1}
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                        style={{ marginTop: "6px" }}
                                      />
                                      <label
                                        htmlFor={`q26f_${data.cohortTreatmentName}_PdaYes_${idx}`}
                                        style={{ textAlign: "start" }}
                                      >
                                        <span className="radio-text-padding">
                                          Yes, agent discontinued
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  {data.lOT === highestLot && (
                                    <div className="">
                                      <div
                                        className="option-without-input"
                                        style={{
                                          display: "flex",
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          id={`q26f_${data.cohortTreatmentName}_PdaNo_${idx}`}
                                          name={`q26f_${data.cohortTreatmentName}_PdaNo_${idx}`}
                                          value={2}
                                          checked={data.discontinueAgent === 2}
                                          onChange={(e) =>
                                            HandleRepeaterFieldChange(
                                              e,
                                              data.cohortTreatmentName,
                                              null,
                                              null,
                                              null,
                                            )
                                          }
                                          style={{ marginTop: "6px" }}
                                        />
                                        <label
                                          htmlFor={`q26f_${data.cohortTreatmentName}_PdaNo_${idx}`}
                                          style={{ textAlign: "start" }}
                                        >
                                          <span className="radio-text-padding">
                                            No, medication ongoing at time of
                                            last encounter
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  )}

                                  <div className="">
                                    <div className="option-without-input">
                                      <input
                                        type="radio"
                                        id={`q26f_${data.cohortTreatmentName}_PdaUnk_${idx}`}
                                        name={`q26f_${data.cohortTreatmentName}_PdaUnk_${idx}`}
                                        value={99}
                                        checked={data.discontinueAgent === 99}
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            null,
                                            null,
                                          )
                                        }
                                      />
                                      <label
                                        htmlFor={`q26f_${data.cohortTreatmentName}_PdaUnk_${idx}`}
                                      >
                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>

                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx].showColFError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26f
                                    }
                                  />
                                </td>
                              ) : (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",
                                    textAlign: "center",
                                    padding: "8px",
                                    textAlign: "start",
                                  }}
                                >
                                  <span
                                    style={{ textAlign: "center" }}
                                    className="not-applicable"
                                  >
                                    <b>Not applicable</b>
                                  </span>
                                </td>
                              )}
                              {bispecificTreatment[idx].showColG &&
                              bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.CARVYKTI &&
                              bispecificTreatment[idx].cohorttreatmentid !=
                                RRMMCohortTreatment.ABECMA ? (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",
                                    textAlign: "center",
                                    padding: "8px",
                                    textAlign: "start",
                                  }}
                                >
                                  <div className="">
                                    {data.reasonForDiscontinuingMedications?.map(
                                      (item, itemidx) => (
                                        <div className="" key={itemidx}>
                                          <div
                                            className=""
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              key={item.reasonid}
                                              id={`discont_${data.cohortTreatmentName}_${item.reasonName + item.supscripttext}_${itemidx}`}
                                              name={`discont_${data.cohortTreatmentName}_${item.reasonName + item.supscripttext}_${itemidx}`}
                                              style={{ marginTop: "6px" }}
                                              checked={item.isSelected}
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  item.reasonName +
                                                    item.supscripttext,
                                                  idx,
                                                  itemidx,
                                                )
                                              }
                                            />
                                            <label
                                              htmlFor={`discont_${data.cohortTreatmentName}_${item.reasonName + item.supscripttext}_${itemidx}`}
                                            >
                                              <span className="radio-text-padding">
                                                {item.reasonName}
                                                {item.supscripttext === null ? (
                                                  ""
                                                ) : (
                                                  <>
                                                    <sup className="supscript">
                                                      {item.supscripttext.slice(
                                                        0,
                                                        2,
                                                      )}
                                                    </sup>
                                                    {item.supscripttext.slice(
                                                      2,
                                                    )}
                                                  </>
                                                )}
                                              </span>
                                            </label>
                                          </div>
                                          {/* AE */}
                                          {item.reasonName ===
                                            DiscontinuationReason.AdverseEvent &&
                                            item.isSelected &&
                                            isNewEcrfA && (
                                              <div
                                                style={{
                                                  marginLeft: "24px",
                                                  marginTop: "6px",
                                                }}
                                              >
                                                {data
                                                  .adverseEventsDiscontinuationreason
                                                  ?.length > 0 &&
                                                  data.adverseEventsDiscontinuationreason.map(
                                                    (ae, aeIdx) => {
                                                      const isAEUnknown =
                                                        ae.reasonName ===
                                                        "AE type unknown";

                                                      return (
                                                        <div key={aeIdx}>
                                                          <label
                                                            className="d-flex align-items-start"
                                                            htmlFor={`adverse_${ae.reasonName}_${idx}_${itemidx}_${aeIdx}`}
                                                          >
                                                            <input
                                                              type={
                                                                isAEUnknown
                                                                  ? "radio"
                                                                  : "checkbox"
                                                              }
                                                              id={`adverse_${ae.reasonName}_${idx}_${itemidx}_${aeIdx}`}
                                                              name={`adverse_${ae.reasonName}_${idx}_${itemidx}_${aeIdx}`}
                                                              checked={
                                                                ae.isSelected
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  ae.reasonName,
                                                                  "Adverse Events",
                                                                  idx, // ✅ always correct
                                                                  itemidx,
                                                                  aeIdx,
                                                                  null,
                                                                )
                                                              }
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                            />

                                                            <span
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                              className="radio-text-padding"
                                                            >
                                                              {ae.reasonName}
                                                            </span>
                                                          </label>
                                                          {ae.reasonName ===
                                                            DiscontinuationReason.NeurologicalEvent &&
                                                            ae.isSelected &&
                                                            isNewEcrfA && (
                                                              <div
                                                                style={{
                                                                  marginLeft:
                                                                    "28px",
                                                                  marginTop:
                                                                    "8px",
                                                                }}
                                                              >
                                                                {data
                                                                  .adverseNeurologicalEventsDiscontinuationreason
                                                                  ?.length >
                                                                  0 &&
                                                                  data.adverseNeurologicalEventsDiscontinuationreason.map(
                                                                    (
                                                                      aeNeuro,
                                                                      aeNeuroIdx,
                                                                    ) => {
                                                                      return (
                                                                        <div
                                                                          key={
                                                                            aeIdx
                                                                          }
                                                                        >
                                                                          <label
                                                                            className="d-flex align-items-start"
                                                                            htmlFor={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                          >
                                                                            <input
                                                                              type="checkbox"
                                                                              id={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                              name={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                              checked={
                                                                                aeNeuro.isSelected
                                                                              }
                                                                              onChange={(
                                                                                e,
                                                                              ) =>
                                                                                HandleRepeaterFieldChange(
                                                                                  e,
                                                                                  data.agentName,
                                                                                  "Adverse Events",
                                                                                  idx,
                                                                                  itemidx,
                                                                                  aeIdx,
                                                                                  aeNeuroIdx,
                                                                                )
                                                                              }
                                                                              style={{
                                                                                marginTop:
                                                                                  "6px",
                                                                              }}
                                                                            />

                                                                            <span
                                                                              style={{
                                                                                textAlign:
                                                                                  "left",
                                                                              }}
                                                                              className="radio-text-padding"
                                                                            >
                                                                              {
                                                                                aeNeuro.reasonName
                                                                              }
                                                                            </span>
                                                                          </label>

                                                                          {aeNeuro.reasonName.includes(
                                                                            "Other",
                                                                          ) && (
                                                                            <label
                                                                              htmlFor={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                            >
                                                                              <span
                                                                                style={{
                                                                                  paddingLeft:
                                                                                    "28px",
                                                                                }}
                                                                                className="radio-text-padding"
                                                                              >
                                                                                <textarea
                                                                                  style={{
                                                                                    width:
                                                                                      "264px",
                                                                                  }}
                                                                                  //className="input-dash"
                                                                                  id={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                  name={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                  type="text"
                                                                                  value={
                                                                                    aeNeuro.reasonText
                                                                                  }
                                                                                  onChange={(
                                                                                    e,
                                                                                  ) =>
                                                                                    HandleRepeaterFieldChange(
                                                                                      e,
                                                                                      data.agentName,
                                                                                      aeNeuro.reasonName,
                                                                                      idx,
                                                                                      itemidx,
                                                                                      aeIdx,
                                                                                      aeNeuroIdx,
                                                                                    )
                                                                                  }
                                                                                  maxLength={
                                                                                    300
                                                                                  }
                                                                                />
                                                                              </span>
                                                                            </label>
                                                                          )}
                                                                        </div>
                                                                      );
                                                                    },
                                                                  )}
                                                              </div>
                                                            )}
                                                        </div>
                                                      );
                                                    },
                                                  )}
                                              </div>
                                            )}

                                          {item.reasonName.includes(
                                            "Other",
                                          ) && (
                                            <label
                                              htmlFor={`discont_${data.cohortTreatmentName}_${item.reasonName}txt_${itemidx}`}
                                            >
                                              <span className="radio-text-padding">
                                                <textarea
                                                  style={{
                                                    width: "264px",
                                                  }}
                                                  //className="input-dash"
                                                  id={`discont_${data.cohortTreatmentName}_${item.reasonName}txt_${itemidx}`}
                                                  name={`discont_${data.cohortTreatmentName}_${item.reasonName}txt_${itemidx}`}
                                                  type="text"
                                                  value={item.reasonText}
                                                  onChange={(e) =>
                                                    HandleRepeaterFieldChange(
                                                      e,
                                                      data.cohortTreatmentName,
                                                      item.reasonName +
                                                        item.supscripttext,
                                                      idx,
                                                      itemidx,
                                                    )
                                                  }
                                                  maxLength={300}
                                                />
                                              </span>
                                            </label>
                                          )}
                                        </div>
                                      ),
                                    )}
                                    <div className="">
                                      <input
                                        type="radio"
                                        id={`discont_unk_${data.cohortTreatmentName}_${idx}`}
                                        name={`discont_unk_${data.cohortTreatmentName}_${idx}`}
                                        value={1}
                                        checked={
                                          data
                                            .reasonForDiscontinuingMedications[0]
                                            .reasonUnk
                                            ? 1
                                            : ""
                                        }
                                        onChange={(e) =>
                                          HandleRepeaterFieldChange(
                                            e,
                                            data.cohortTreatmentName,
                                            null,
                                            idx,
                                            null,
                                          )
                                        }
                                      />
                                      <label
                                        htmlFor={`discont_unk_${data.cohortTreatmentName}_${idx}`}
                                      >
                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx].showColGError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26g
                                    }
                                  />
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      bispecificTreatment[idx].showColGOthError
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26ga
                                    }
                                  />

                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={data.showAdverseEventError == true}
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26ae
                                    }
                                  />
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      data.showAdverseNeuroEventError == true
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26aeNeuro
                                    }
                                  />
                                  <ErrorField
                                    style={{ padding: "0px" }}
                                    show={
                                      data.showAdverseNeuroEventOtherTextError ==
                                      true
                                    }
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q26aeNeuroOther
                                    }
                                  />
                                </td>
                              ) : (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    alignContent: "flex-start",
                                    textAlign: "center",
                                    padding: "8px",
                                    //textAlign: 'start'
                                  }}
                                >
                                  <span
                                    style={{ textAlign: "center" }}
                                    className="not-applicable"
                                  >
                                    <b>Not applicable</b>
                                  </span>
                                </td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Q26.1 */}
          {bispecificAgent?.length > 0 && isNewEcrfA && (
            <div className="survey-question-content calender-datefix-survey">
              <div className="question-answer">
                {/* Q26 */}
                <div className="question-bot-sapce">
                  <div className="question question-weight">
                    <span>Q26.1.</span>
                    <span className="quest-text-pad">
                      Please describe the prescribed dosing information for each
                      additional agent used in combination with a
                      Bispecific/CAR-T treatment. Like above, please note the
                      following:{" "}
                    </span>
                  </div>{" "}
                  <div className="question question-weight">
                    <div className="quest-text-pad">
                      <p>
                        (a) Date of first administration of each agent must be
                        no later than the date of last administration of the
                        same agent.
                      </p>

                      <p>
                        (b) None of the dates of first administration or last
                        administration should be later than the end of follow up
                        on{" "}
                        <span style={{ color: PageDesignConstants.fontColor }}>
                          {endFollowUpDate
                            ? endFollowUpDate
                            : "[end of follow up]"}
                        </span>
                        .
                      </p>

                      <p>
                        (c) If a medication agent’s discontinuation status is
                        “No, medication ongoing at time of last encounter”
                        below, please enter the “Date of the last
                        administration” as the last known administration date on
                        or prior to the patient’s last encounter date on{" "}
                        <span style={{ color: PageDesignConstants.fontColor }}>
                          {lastEncounterDate
                            ? lastEncounterDate
                            : "[date of last encounter]"}
                        </span>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="question-answer">
                <div className="question-bot-sapce">
                  <div className=" double-dig-answer">
                    <div className="" style={{ overflowX: "auto" }}>
                      {bispecificAgent?.length > 0 &&
                        bispecificAgent.map((mainData, idx) => (
                          <div key={idx} style={{ marginBottom: "20px" }}>
                            {/* Cohort Name */}
                            <h4 style={{ marginBottom: "10px" }}>
                              {mainData.cohortTreatmentName}
                            </h4>

                            <table
                              style={{
                                border: "1px solid black",
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Medication
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "135px",
                                    }}
                                  >
                                    <span
                                      data-tooltip-id="encounterTip"
                                      className="modal-popup"
                                      onClick={() =>
                                        setShowHideHyperlinkModal(true)
                                      }
                                    >
                                      Line Of Therapy
                                    </span>
                                    {showHideHyperlinkModal && (
                                      <InfoPopUp
                                        description={hyperlinkTextLineOfTherapy}
                                        OkClick={() =>
                                          setShowHideHyperlinkModal(false)
                                        }
                                      />
                                    )}
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Date of first administration
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Date of last administration
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "195px",
                                    }}
                                  >
                                    Number of administrations
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "305px",
                                    }}
                                  >
                                    Dose at first administration
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "250px",
                                    }}
                                  >
                                    Did patient discontinue agent?
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      minWidth: "300px",
                                    }}
                                  >
                                    Reason for discontinuing
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {mainData?.agentLists?.length > 0 ? (
                                  mainData.agentLists.map((data, agentIdx) => (
                                    <tr key={agentIdx}>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {data.agentName}
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {data.lot}
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {data.cohortIndexDate}
                                      </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <div className="">
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={`q26_one_date_last_admin_radio_${data.agentName}_${idx}`}
                                                      name={`q26_one_date_last_admin_radio_${data.agentName}_${idx}`}
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      value={1}
                                                      checked={
                                                        data.lastDateRadio === 1
                                                      }
                                                      onChange={(e) =>
                                                        HandleQ26OneRepeaterFieldChange(
                                                          e,
                                                          data.agentName,
                                                          null,
                                                          null,
                                                          null,
                                                        )
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding datepicker-dependence calender-datefix"
                                                      style={{
                                                        paddingLeft: "5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`q26_one_last_admin_date_${idx}`}
                                                        HandleDateChange={(
                                                          name,
                                                          value,
                                                        ) => {
                                                          HandleQ26OneDateChange(
                                                            name,
                                                            value,
                                                            data.agentName,
                                                          );
                                                        }}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                        date={data.lastDate}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        textAlign: "start",
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q26_one_${data.agentName}_LUnk_${idx}`}
                                                        name={`q26_one_${data.agentName}_LUnk_${idx}`}
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        value={1}
                                                        checked={
                                                          data.lastDateUnk === 1
                                                        }
                                                        onChange={(e) =>
                                                          HandleQ26OneRepeaterFieldChange(
                                                            e,
                                                            data.agentName,
                                                            null,
                                                            null,
                                                            null,
                                                          )
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Date of last
                                                        administration unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  style={{ padding: "0px" }}
                                                  show={data.showColDError}
                                                  message={
                                                    BispecificCartTreatmentCohort_Msgs.q26d
                                                  }
                                                />
                                                <ErrorField
                                                  style={{ padding: "0px" }}
                                                  show={
                                                    data.agentDateRangeError ==
                                                    true
                                                  }
                                                  message={
                                                    "Please ensure that the date of last administration is after the treatment initiation date and Bispecifics/CAR-T agent index date, and or before end of follow-up date."
                                                  }
                                                />

                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={data.agentDateError == true}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26d_date
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.lastAdministrationSoftError ==
                                            true
                                          }
                                          message={"WARNING: you have noted that the medication is ongoing at the time of last encounter and listed the date of last administration as Unknown. Please provide the date of the last known administration of the medication prior to the patient’s last encounter on [date of last encounter] or infer the date of last known administration using information provided within the patient’s chart, if possible. Only state that the date of last administration is unknown if there are no known administrations of the medication during this line of therapy.".replace(
                                            "[date of last encounter]",
                                            lastEncounterDate ||
                                              "[date of last encounter]",
                                          )}
                                        />
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <div
                                          className="option-fbox"
                                          style={{ width: "216px" }}
                                        >
                                          <label
                                            htmlFor={`q26_one_${data.agentName}_No_Admin_${idx}`}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26_one_${data.agentName}_No_Admin_${idx}`}
                                              name={`q26_one_${data.agentName}_No_Admin_${idx}`}
                                              value={1}
                                              checked={
                                                data.noOfAdmissionRadio === 1
                                              }
                                              onChange={(e) =>
                                                HandleQ26OneRepeaterFieldChange(
                                                  e,
                                                  data.agentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                          </label>
                                          <label
                                            htmlFor={`q26e_${data.agentName}_Noatxt_${idx}`}
                                          >
                                            <span className="radio-text-padding">
                                              <input
                                                className="input-dash"
                                                id={`q26_one_${data.agentName}_No_Admintxt_${idx}`}
                                                name={`q26_one_${data.agentName}_No_Admintxt_${idx}`}
                                                type="text"
                                                value={data.noOfAdmission}
                                                min={1}
                                                max={4000}
                                                // maxLength={3}
                                                onKeyDown={(e) => {
                                                  // Prevent entering '.', 'e', '+', '-', and any non-numeric characters
                                                  if (
                                                    [
                                                      ".",
                                                      "e",
                                                      "+",
                                                      "-",
                                                      "E",
                                                    ].includes(e.key) ||
                                                    (e.key.length === 1 &&
                                                      !/[0-9]/.test(e.key))
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  HandleQ26OneRepeaterFieldChange(
                                                    e,
                                                    data.agentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                            </span>
                                          </label>
                                          {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                        </div>
                                        <div
                                          className="option-without-input"
                                          style={{ width: "216px" }}
                                        >
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={`q26_one_${data.agentName}_No_Admin_Unk_${idx}`}
                                              name={`q26_one_${data.agentName}_No_Admin_Unk_${idx}`}
                                              value={1}
                                              checked={
                                                data.noOfAdmissionUnk === 1
                                              }
                                              onChange={(e) =>
                                                HandleQ26OneRepeaterFieldChange(
                                                  e,
                                                  data.agentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                            <span
                                              className="radio-text-padding"
                                              style={{
                                                textAlign: "left",
                                              }}
                                            >
                                              Unknown, please specify dosing
                                              schedule:
                                              <textarea
                                                className="input-dash"
                                                id={`q26_one_${data.agentName}_No_Admin_Unktxt_${idx}`}
                                                name={`q26_one_${data.agentName}_No_Admin_Unktxt_${idx}`}
                                                type="text"
                                                value={data.noOfAdmissionUnkTxt}
                                                onChange={(e) =>
                                                  HandleQ26OneRepeaterFieldChange(
                                                    e,
                                                    data.agentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                            </span>
                                          </label>
                                        </div>
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={data.showColEError}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26e
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={data.showColEUkTxtError}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26eTxt
                                          }
                                        />
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <div className="option-fbox">
                                          <label
                                            htmlFor={`q26_one_${data.agentName}_mg_${idx}`}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26_one_${data.agentName}_mg_${idx}`}
                                              name={`q26_one_${data.agentName}_mg_${idx}`}
                                              value={1}
                                              checked={
                                                data.doseAdministrationRadiomg ===
                                                1
                                              }
                                              onChange={(e) =>
                                                HandleQ26OneRepeaterFieldChange(
                                                  e,
                                                  data.agentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                          </label>
                                          <label
                                            htmlFor={`q26_one_${data.agentName}_mgtxt_${idx}`}
                                          >
                                            <span className="radio-text-padding">
                                              <input
                                                className="input-dash-custom"
                                                id={`q26_one_${data.agentName}_mgtxt_${idx}`}
                                                name={`q26_one_${data.agentName}_mgtxt_${idx}`}
                                                type="text"
                                                value={
                                                  data.doseAdministrationmg
                                                }
                                                min={0}
                                                max={4000}
                                                // maxLength={3}
                                                onKeyDown={(e) => {
                                                  // Allow backspace, arrow keys, delete, and tab
                                                  if (
                                                    [
                                                      "Backspace",
                                                      "ArrowLeft",
                                                      "ArrowRight",
                                                      "Delete",
                                                      "Tab",
                                                    ].includes(e.key)
                                                  ) {
                                                    return;
                                                  }
                                                  // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                  if (
                                                    !/[0-9.]/.test(e.key) ||
                                                    (e.key === "." &&
                                                      e.target.value.includes(
                                                        ".",
                                                      ))
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  const value = e.target.value;
                                                  const selectionStart =
                                                    e.target.selectionStart;
                                                  const newValue =
                                                    value.slice(
                                                      0,
                                                      selectionStart,
                                                    ) +
                                                    e.key +
                                                    value.slice(
                                                      e.target.selectionEnd,
                                                    );
                                                  // Prevent '.' as the first character
                                                  if (
                                                    e.key === "." &&
                                                    value === ""
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  // Allow only one digit after decimal point
                                                  if (
                                                    newValue.includes(".") &&
                                                    newValue.split(".")[1]
                                                      .length > 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  HandleQ26OneRepeaterFieldChange(
                                                    e,
                                                    data.agentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />{" "}
                                              &nbsp; mg
                                            </span>
                                          </label>
                                          {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                        </div>
                                        <br />
                                        <div className="option-fbox">
                                          <label
                                            htmlFor={`q26_one_${data.agentName}_kg_${idx}`}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26_one_${data.agentName}_kg_${idx}`}
                                              name={`q26_one_${data.agentName}_kg_${idx}`}
                                              value={1}
                                              checked={
                                                data.doseAdministrationRadiokg ===
                                                1
                                              }
                                              onChange={(e) =>
                                                HandleQ26OneRepeaterFieldChange(
                                                  e,
                                                  data.agentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                          </label>
                                          <label
                                            htmlFor={`q26_one_${data.agentName}_kgtxt_${idx}`}
                                          >
                                            <span className="radio-text-padding">
                                              <input
                                                className="input-dash-custom"
                                                id={`q26_one_${data.agentName}_kgtxt_${idx}`}
                                                name={`q26_one_${data.agentName}_kgtxt_${idx}`}
                                                type="text"
                                                value={
                                                  data.doseAdministrationkg
                                                }
                                                min={0}
                                                max={4000}
                                                // maxLength={3}
                                                onKeyDown={(e) => {
                                                  // Allow backspace, arrow keys, delete, and tab
                                                  if (
                                                    [
                                                      "Backspace",
                                                      "ArrowLeft",
                                                      "ArrowRight",
                                                      "Delete",
                                                      "Tab",
                                                    ].includes(e.key)
                                                  ) {
                                                    return;
                                                  }
                                                  // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                  if (
                                                    !/[0-9.]/.test(e.key) ||
                                                    (e.key === "." &&
                                                      e.target.value.includes(
                                                        ".",
                                                      ))
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  const value = e.target.value;
                                                  const selectionStart =
                                                    e.target.selectionStart;
                                                  const newValue =
                                                    value.slice(
                                                      0,
                                                      selectionStart,
                                                    ) +
                                                    e.key +
                                                    value.slice(
                                                      e.target.selectionEnd,
                                                    );
                                                  // Prevent '.' as the first character
                                                  if (
                                                    e.key === "." &&
                                                    value === ""
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  // Allow only one digit after decimal point
                                                  if (
                                                    newValue.includes(".") &&
                                                    newValue.split(".")[1]
                                                      .length > 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  HandleQ26OneRepeaterFieldChange(
                                                    e,
                                                    data.agentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                            </span>{" "}
                                            &nbsp; mg/kg
                                          </label>
                                          {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                        </div>
                                        <br />
                                        <div className="option-fbox">
                                          <label
                                            htmlFor={`q26_one_${data.agentName}_m_${idx}`}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26_one_${data.agentName}_m_${idx}`}
                                              name={`q26_one_${data.agentName}_m_${idx}`}
                                              value={1}
                                              checked={
                                                data.doseAdministrationRadiomgm ===
                                                1
                                              }
                                              onChange={(e) =>
                                                HandleQ26OneRepeaterFieldChange(
                                                  e,
                                                  data.agentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                          </label>
                                          <label
                                            htmlFor={`q26_one_${data.agentName}_mtxt_${idx}`}
                                          >
                                            <span className="radio-text-padding">
                                              <input
                                                className="input-dash-custom"
                                                id={`q26_one_${data.agentName}_mtxt_${idx}`}
                                                name={`q26_one_${data.agentName}_mtxt_${idx}`}
                                                type="text"
                                                value={
                                                  data.doseAdministrationmgm
                                                }
                                                min={0}
                                                max={4000}
                                                // maxLength={3}
                                                onKeyDown={(e) => {
                                                  // Allow backspace, arrow keys, delete, and tab
                                                  if (
                                                    [
                                                      "Backspace",
                                                      "ArrowLeft",
                                                      "ArrowRight",
                                                      "Delete",
                                                      "Tab",
                                                    ].includes(e.key)
                                                  ) {
                                                    return;
                                                  }
                                                  // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                  if (
                                                    !/[0-9.]/.test(e.key) ||
                                                    (e.key === "." &&
                                                      e.target.value.includes(
                                                        ".",
                                                      ))
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  const value = e.target.value;
                                                  const selectionStart =
                                                    e.target.selectionStart;
                                                  const newValue =
                                                    value.slice(
                                                      0,
                                                      selectionStart,
                                                    ) +
                                                    e.key +
                                                    value.slice(
                                                      e.target.selectionEnd,
                                                    );
                                                  // Prevent '.' as the first character
                                                  if (
                                                    e.key === "." &&
                                                    value === ""
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  // Allow only one digit after decimal point
                                                  if (
                                                    newValue.includes(".") &&
                                                    newValue.split(".")[1]
                                                      .length > 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  HandleQ26OneRepeaterFieldChange(
                                                    e,
                                                    data.agentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                            </span>{" "}
                                            &nbsp; mg/m<sup>2</sup>
                                          </label>
                                          {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                        </div>
                                        <br />

                                        <div className="">
                                          <div className="option-without-input">
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={`q26_one_${data.agentName}_doseUnk_${idx}`}
                                                name={`q26_one_${data.agentName}_doseUnk_${idx}`}
                                                value={99}
                                                checked={
                                                  data.doseAdministrationRadioUnknown ===
                                                  99
                                                }
                                                onChange={(e) =>
                                                  HandleQ26OneRepeaterFieldChange(
                                                    e,
                                                    data.agentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />

                                              <span className="radio-text-padding">
                                                Unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={data.showColHError}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26h
                                          }
                                        />
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <div className="">
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26_1_${data.agentName}_PdaYes_${idx}`}
                                              name={`q26_1_${data.agentName}_PdaYes_${idx}`}
                                              value={1}
                                              checked={
                                                data.discontinueAgent === 1
                                              }
                                              onChange={(e) =>
                                                HandleQ26OneRepeaterFieldChange(
                                                  e,
                                                  data.agentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                              style={{
                                                marginTop: "6px",
                                              }}
                                            />
                                            <label
                                              htmlFor={`q26_1_${data.agentName}_PdaYes_${idx}`}
                                              style={{
                                                textAlign: "start",
                                              }}
                                            >
                                              <span className="radio-text-padding">
                                                Yes, agent discontinued
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        {data.lOT === highestLot && (
                                          <div className="">
                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <label
                                                className="d-flex align-items-start"
                                                htmlFor={`q26_1_${data.agentName}_PdaNo_${idx}`}
                                                style={{
                                                  textAlign: "start",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={`q26_1_${data.agentName}_PdaNo_${idx}`}
                                                  name={`q26_1_${data.agentName}_PdaNo_${idx}`}
                                                  value={2}
                                                  checked={
                                                    data.discontinueAgent === 2
                                                  }
                                                  onChange={(e) =>
                                                    HandleQ26OneRepeaterFieldChange(
                                                      e,
                                                      data.agentName,
                                                      null,
                                                      null,
                                                      null,
                                                    )
                                                  }
                                                  style={{
                                                    marginTop: "6px",
                                                  }}
                                                />

                                                <span className="radio-text-padding">
                                                  No, medication ongoing at time
                                                  of last encounter
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                        )}

                                        <div className="">
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26_one_${data.agentName}_PdaUnk_${idx}`}
                                              name={`q26_one_${data.agentName}_PdaUnk_${idx}`}
                                              value={99}
                                              checked={
                                                data.discontinueAgent === 99
                                              }
                                              onChange={(e) =>
                                                HandleQ26OneRepeaterFieldChange(
                                                  e,
                                                  data.agentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                            <label
                                              htmlFor={`q26_one_${data.agentName}_PdaUnk_${idx}`}
                                            >
                                              <span className="radio-text-padding">
                                                Unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={data.showColFError}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26f
                                          }
                                        />
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {data.discontinueAgent === 1 && (
                                          <div className="">
                                            {data.reasonForDiscontinuingMedications?.map(
                                              (item, itemidx) => (
                                                <div className="" key={itemidx}>
                                                  <div
                                                    className=""
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label
                                                      className="d-flex align-items-start"
                                                      htmlFor={`Q26_one_discont_${
                                                        data.agentName
                                                      }_${
                                                        item.reasonName +
                                                        item.supscripttext
                                                      }_${itemidx}`}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        key={item.reasonid}
                                                        id={`Q26_one_discont_${
                                                          data.agentName
                                                        }_${
                                                          item.reasonName +
                                                          item.supscripttext
                                                        }_${itemidx}`}
                                                        name={`discont_${
                                                          data.agentName
                                                        }_${
                                                          item.reasonName +
                                                          item.supscripttext
                                                        }_${itemidx}`}
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        checked={
                                                          item.isSelected
                                                        }
                                                        onChange={(e) =>
                                                          HandleQ26OneRepeaterFieldChange(
                                                            e,
                                                            data.agentName,
                                                            item.reasonName +
                                                              item.supscripttext,
                                                            idx,
                                                            itemidx,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          textAlign: "left",
                                                        }}
                                                        className="radio-text-padding "
                                                      >
                                                        {item.reasonName}
                                                        {item.supscripttext ===
                                                        null ? (
                                                          ""
                                                        ) : (
                                                          <>
                                                            <sup className="supscript">
                                                              {item.supscripttext.slice(
                                                                0,
                                                                2,
                                                              )}
                                                            </sup>
                                                            {item.supscripttext.slice(
                                                              2,
                                                            )}
                                                          </>
                                                        )}
                                                      </span>
                                                    </label>
                                                  </div>
                                                  {item.reasonName ===
                                                    DiscontinuationReason.AdverseEvent &&
                                                    item.isSelected && (
                                                      <div
                                                        style={{
                                                          marginLeft: "24px",
                                                          marginTop: "6px",
                                                        }}
                                                      >
                                                        {data
                                                          .adverseEventsDiscontinuationreason
                                                          ?.length > 0 &&
                                                          data.adverseEventsDiscontinuationreason.map(
                                                            (ae, aeIdx) => {
                                                              const isAEUnknown =
                                                                ae.reasonName ===
                                                                "AE type unknown";

                                                              return (
                                                                <div
                                                                  key={aeIdx}
                                                                >
                                                                  <label
                                                                    className="d-flex align-items-start"
                                                                    htmlFor={`adverse_${data.agentName}_${itemidx}_${aeIdx}`}
                                                                  >
                                                                    <input
                                                                      type={
                                                                        isAEUnknown
                                                                          ? "radio"
                                                                          : "checkbox"
                                                                      }
                                                                      id={`adverse_${data.agentName}_${itemidx}_${aeIdx}`}
                                                                      name={`adverse_${data.agentName}_${itemidx}_${aeIdx}`}
                                                                      checked={
                                                                        ae.isSelected
                                                                      }
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        HandleQ26OneRepeaterFieldChange(
                                                                          e,
                                                                          data.agentName,
                                                                          "Adverse Events",
                                                                          idx,
                                                                          itemidx,
                                                                          aeIdx,
                                                                        )
                                                                      }
                                                                      style={{
                                                                        marginTop:
                                                                          "6px",
                                                                      }}
                                                                    />

                                                                    <span
                                                                      style={{
                                                                        textAlign:
                                                                          "left",
                                                                      }}
                                                                      className="radio-text-padding"
                                                                    >
                                                                      {
                                                                        ae.reasonName
                                                                      }
                                                                    </span>
                                                                  </label>
                                                                  {ae.reasonName ===
                                                                    DiscontinuationReason.NeurologicalEvent &&
                                                                    ae.isSelected && (
                                                                      <div
                                                                        style={{
                                                                          marginLeft:
                                                                            "28px",
                                                                          marginTop:
                                                                            "8px",
                                                                        }}
                                                                      >
                                                                        {data
                                                                          .adverseNeurologicalEventsDiscontinuationreason
                                                                          ?.length >
                                                                          0 &&
                                                                          data.adverseNeurologicalEventsDiscontinuationreason.map(
                                                                            (
                                                                              aeNeuro,
                                                                              aeNeuroIdx,
                                                                            ) => {
                                                                              return (
                                                                                <div
                                                                                  key={
                                                                                    aeIdx
                                                                                  }
                                                                                >
                                                                                  <label
                                                                                    className="d-flex align-items-start"
                                                                                    htmlFor={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                  >
                                                                                    <input
                                                                                      type="checkbox"
                                                                                      id={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      name={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      checked={
                                                                                        aeNeuro.isSelected
                                                                                      }
                                                                                      onChange={(
                                                                                        e,
                                                                                      ) =>
                                                                                        HandleQ26OneRepeaterFieldChange(
                                                                                          e,
                                                                                          data.agentName,
                                                                                          "Adverse Events",
                                                                                          idx,
                                                                                          itemidx,
                                                                                          aeIdx,
                                                                                          aeNeuroIdx,
                                                                                        )
                                                                                      }
                                                                                      style={{
                                                                                        marginTop:
                                                                                          "6px",
                                                                                      }}
                                                                                    />

                                                                                    <span
                                                                                      style={{
                                                                                        textAlign:
                                                                                          "left",
                                                                                      }}
                                                                                      className="radio-text-padding"
                                                                                    >
                                                                                      {
                                                                                        aeNeuro.reasonName
                                                                                      }
                                                                                    </span>
                                                                                  </label>

                                                                                  {aeNeuro.reasonName.includes(
                                                                                    "Other",
                                                                                  ) && (
                                                                                    <label
                                                                                      htmlFor={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                    >
                                                                                      <span
                                                                                        style={{
                                                                                          paddingLeft:
                                                                                            "28px",
                                                                                        }}
                                                                                        className="radio-text-padding"
                                                                                      >
                                                                                        <textarea
                                                                                          style={{
                                                                                            width:
                                                                                              "264px",
                                                                                          }}
                                                                                          //className="input-dash"
                                                                                          id={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                          name={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                          type="text"
                                                                                          value={
                                                                                            aeNeuro.reasonText
                                                                                          }
                                                                                          onChange={(
                                                                                            e,
                                                                                          ) =>
                                                                                            HandleQ26OneRepeaterFieldChange(
                                                                                              e,
                                                                                              data.agentName,
                                                                                              aeNeuro.reasonName,
                                                                                              idx,
                                                                                              itemidx,
                                                                                              aeIdx,
                                                                                              aeNeuroIdx,
                                                                                            )
                                                                                          }
                                                                                          maxLength={
                                                                                            300
                                                                                          }
                                                                                        />
                                                                                      </span>
                                                                                    </label>
                                                                                  )}
                                                                                </div>
                                                                              );
                                                                            },
                                                                          )}
                                                                      </div>
                                                                    )}
                                                                </div>
                                                              );
                                                            },
                                                          )}
                                                      </div>
                                                    )}

                                                  {item.reasonName.includes(
                                                    "Other",
                                                  ) && (
                                                    <label
                                                      htmlFor={`discont_${data.agentName}_${item.reasonName}txt_${itemidx}`}
                                                    >
                                                      <span className="radio-text-padding">
                                                        <textarea
                                                          style={{
                                                            width: "264px",
                                                          }}
                                                          //className="input-dash"
                                                          id={`discont_${data.agentName}_${item.reasonName}txt_${itemidx}`}
                                                          name={`discont_${data.agentName}_${item.reasonName}txt_${itemidx}`}
                                                          type="text"
                                                          value={
                                                            item.reasonText
                                                          }
                                                          onChange={(e) =>
                                                            HandleQ26OneRepeaterFieldChange(
                                                              e,
                                                              data.agentName,
                                                              item.reasonName +
                                                                item.supscripttext,
                                                              idx,
                                                              itemidx,
                                                            )
                                                          }
                                                          maxLength={300}
                                                        />
                                                      </span>
                                                    </label>
                                                  )}
                                                </div>
                                              ),
                                            )}
                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                id={`discont_unk_${data.agentName}_${idx}`}
                                                name={`discont_unk_${data.agentName}_${idx}`}
                                                value={true}
                                                checked={
                                                  data
                                                    .reasonForDiscontinuingMedications[0]
                                                    .reasonUnk
                                                    ? true
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  HandleQ26OneRepeaterFieldChange(
                                                    e,
                                                    data.agentName,
                                                    null,
                                                    idx,
                                                    null,
                                                  )
                                                }
                                              />
                                              <label
                                                htmlFor={`discont_unk_${data.agentName}_${idx}`}
                                              >
                                                <span className="radio-text-padding">
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                        )}
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={data.showColGError}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26g
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={data.showColGOthError}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26ga
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.discontinuationSoftError ==
                                            true
                                          }
                                          message={
                                            "WARNING: you have indicated that at least 1 reason for medication discontinuation was death however no date of death is reported in Q20. Please revise the reason for medication discontinuation to a reason besides death or otherwise add a date of death in Q20."
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.discontinuationUnkSoftError ==
                                            true
                                          }
                                          message={
                                            "WARNING: the discontinuation status for this medication has been listed as unknown. Please attempt to infer the discontinuation status using information provided within the patient chart. Only use the unknown option if there is truly no information reported on medication discontinuation status."
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.showAdverseEventError == true
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26ae
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.showAdverseNeuroEventError ==
                                            true
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26aeNeuro
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.showAdverseNeuroEventOtherTextError ==
                                            true
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26aeNeuroOther
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={8}
                                      style={{
                                        textAlign: "center",
                                        padding: "10px",
                                      }}
                                    >
                                      No agents available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isNewEcrfA &&
            bispecificHighestLotList &&
            bispecificHighestLotList.length > 0 && (
              <div className="survey-question-content calender-datefix-survey">
                <div className="question-answer">
                  <div className="question-bot-sapce">
                    <div className="question question-weight">
                      <span>Q26.2.</span>
                      <span className="quest-text-pad">
                        Please provide information on all prior lines of therapy
                        (LOTs) received for this patient before initiating
                        treatment with{" "}
                        <span style={{ color: PageDesignConstants.fontColor }}>
                          <b>
                            {bispecificHighestLotList[0].cohorttreatmentid ===
                            null
                              ? "[Bispecifics/CAR-T with the highest LOT number]"
                              : bispecificHighestLotList[0].cohorttreatmentName}
                            .
                          </b>{" "}
                        </span>
                        <br />
                        <b>
                          <u>
                            {" "}
                            If a LOT end date is not available within the
                            patient chart, please define as the start date of
                            the subsequent LOT – 1 day.
                          </u>
                        </b>{" "}
                        If no subsequent LOT was received, indicate that the end
                        date is <i>Unknown</i>.{" "}
                      </span>
                    </div>
                    <div className="sub-question">
                      <div className="" style={{ overflowX: "auto" }}>
                        <table
                          style={{
                            border: "1px solid black",
                            borderCollapse: "collapse",
                            width: "100%",
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                  textAlign: "center",
                                  width: "10%",
                                }}
                              >
                                LOT
                              </th>
                              <th
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                  textAlign: "center",
                                  width: "20%",
                                }}
                              >
                                LOT start date
                              </th>
                              <th
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                  textAlign: "center",
                                  width: "20%",
                                }}
                              >
                                LOT end date
                              </th>
                              <th
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                  textAlign: "center",
                                  width: "20%",
                                }}
                              >
                                Treatments Received
                              </th>
                              <th
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                  textAlign: "center",
                                  width: "15%",
                                }}
                              >
                                SCT Received on LOT?
                              </th>
                              <th
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                  textAlign: "center",
                                  width: "15%",
                                }}
                              >
                                Refractory to Treatment?
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {bispecificHighestLotList.map((row, idx) => (
                              <tr key={idx}>
                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    alignContent: "flex-start",
                                  }}
                                >
                                  <div>
                                    {" "}
                                    {/*  className="double-dig-answer" */}
                                    <div className="long-text-option">
                                      <label>
                                        <span className="radio-text-padding">
                                          <span
                                            style={{
                                              color:
                                                PageDesignConstants.fontColor,
                                            }}
                                          >
                                            {row.q262_rbl_A}
                                          </span>
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </td>

                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    alignContent: "flex-start",
                                  }}
                                >
                                  <>
                                    <div className="">
                                      {/* double-dig-answer */}
                                      <div className="long-text-option">
                                        <input
                                          type="radio"
                                          id={idx}
                                          name={"q262_rbl_B" + idx}
                                          value={1}
                                          checked={row.q262_rbl_B === 1}
                                          onChange={Handle262FieldChange}
                                        />
                                        <span className="date-field-padding">
                                          {!isStringEmpty(
                                            row.q262_autodate_B,
                                          ) ? (
                                            row.q262_autodate_B
                                          ) : (
                                            <DatePickerComponent
                                              ctrlId={"q262_date_B" + idx}
                                              HandleDateChange={
                                                Handle262DateChange
                                              }
                                              minDate={dayjs("01-01-1920")}
                                              maxDate={dayjs()}
                                              locale="en"
                                              date={row.q262_date_B}
                                              optionId={idx}
                                            />
                                          )}
                                        </span>
                                      </div>
                                      {isStringEmpty(row.q262_autodate_B) && (
                                        <div>
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"q262_rbl_B" + idx}
                                              value={99}
                                              checked={row.q262_rbl_B === 99}
                                              onChange={Handle262FieldChange}
                                            />
                                            <span className="radio-text-padding">
                                              Date unknown
                                            </span>
                                          </label>
                                        </div>
                                      )}
                                    </div>
                                    <ErrorField
                                      show={row.q262_B_empty_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q262_B
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_B_unk_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q262_BC_Warning
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_B_before_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q262_AfterPrevLot
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_B_beyond_eof_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.Q32c_LessThanEOF
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_B_before_next_lot_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q32_MoreThanNxtLotStart
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_B_invalid_date}
                                      message={CommonError_Msgs.InvalidDate}
                                      style={{ paddingLeft: "0px" }}
                                    />
                                  </>
                                </td>

                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    alignContent: "flex-start",
                                  }}
                                >
                                  <>
                                    <div className="">
                                      {/* double-dig-answer */}
                                      <div className="long-text-option">
                                        <input
                                          type="radio"
                                          id={idx}
                                          name={"q262_rbl_C" + idx}
                                          value={1}
                                          checked={row.q262_rbl_C === 1}
                                          onChange={Handle262FieldChange}
                                        />
                                        <span className="date-field-padding">
                                          {!isStringEmpty(
                                            row.q262_autodate_C,
                                          ) ? (
                                            row.q262_autodate_C
                                          ) : (
                                            <DatePickerComponent
                                              ctrlId={"q262_date_C" + idx}
                                              HandleDateChange={
                                                Handle262DateChange
                                              }
                                              minDate={dayjs("01-01-1920")}
                                              maxDate={dayjs()}
                                              locale="en"
                                              date={row.q262_date_C}
                                              optionId={idx}
                                            />
                                          )}
                                        </span>
                                      </div>
                                      {isStringEmpty(row.q262_autodate_C) && (
                                        <div>
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"q262_rbl_C" + idx}
                                              value={99}
                                              checked={row.q262_rbl_C === 99}
                                              onChange={Handle262FieldChange}
                                            />
                                            <span className="radio-text-padding">
                                              Date unknown
                                            </span>
                                          </label>
                                        </div>
                                      )}
                                    </div>
                                    <ErrorField
                                      show={row.q262_C_empty_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q262_C
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_C_unk_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q262_BC_Warning
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_C_before_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q262_AfterLotStart
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_C_beyond_eof_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.Q32c_LessThanEOF
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_C_before_next_lot_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q32_MoreThanNxtLotStart
                                      }
                                      style={{ paddingLeft: "0px" }}
                                    />
                                    <ErrorField
                                      show={row.q262_C_invalid_date}
                                      message={CommonError_Msgs.InvalidDate}
                                      style={{ paddingLeft: "0px" }}
                                    />
                                  </>
                                </td>

                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    alignContent: "flex-start",
                                  }}
                                >
                                  <>
                                    <div className="">
                                      {row.prescribedTreatments &&
                                        row.prescribedTreatments.length > 0 &&
                                        (() => {
                                          const cohort = cohortConfig.find(
                                            (c) =>
                                              c.cohortIds.includes(
                                                row.bindedCohorttreatmentid,
                                              ),
                                          );

                                          const flag = cohort?.flag;
                                          const isCohortUndefined =
                                            row.bindedCohorttreatmentid == null;

                                          return (
                                            row.q262_rbl_A >= 1 &&
                                            row.prescribedTreatments.map(
                                              (category, index) =>
                                                (isCohortUndefined ||
                                                  category?.treatments?.some(
                                                    (x) => x[flag] === true,
                                                  )) && (
                                                  <div
                                                    key={index}
                                                    style={{
                                                      paddingBottom: "10px",
                                                    }}
                                                  >
                                                    <h6>
                                                      {category?.category}
                                                    </h6>

                                                    {category.treatments
                                                      .filter((x) =>
                                                        isCohortUndefined
                                                          ? true
                                                          : x[flag] === true,
                                                      )
                                                      .map((item) => (
                                                        <div
                                                          key={
                                                            item.prescribedTreatmentId
                                                          }
                                                        >
                                                          <label
                                                            className={`long-text-option ${
                                                              item.name ===
                                                              "Other, please specify"
                                                                ? undefined
                                                                : "radio-text-padding"
                                                            }`}
                                                          >
                                                            <input
                                                              type="checkbox"
                                                              id={`${idx}_${item.prescribedTreatmentId}`}
                                                              name={`chk_q262_received_tmt${idx}_${item.prescribedTreatmentId}`}
                                                              checked={row.q262_selectedReceivedTmtList?.some(
                                                                (a) =>
                                                                  a.prescribedTreatmentId ===
                                                                  item.prescribedTreatmentId,
                                                              )}
                                                              onChange={
                                                                Handle262FieldChange
                                                              }
                                                            />

                                                            {item.name ===
                                                            "Other, please specify" ? (
                                                              <span className="radio-text-padding">
                                                                {item.name}:{" "}
                                                                <textarea
                                                                  style={{
                                                                    width:
                                                                      "264px",
                                                                  }}
                                                                  id={`${idx}_${item.prescribedTreatmentId}`}
                                                                  name="q262_txt_received_tmt_oth"
                                                                  value={
                                                                    row.q262_selectedReceivedTmtList?.find(
                                                                      (a) =>
                                                                        a.prescribedTreatmentId ===
                                                                        item.prescribedTreatmentId,
                                                                    )
                                                                      ?.prescribedTreatmentOthTxt ??
                                                                    ""
                                                                  }
                                                                  onChange={
                                                                    Handle262FieldChange
                                                                  }
                                                                  maxLength={
                                                                    300
                                                                  }
                                                                  className="option-fbox"
                                                                />
                                                              </span>
                                                            ) : (
                                                              <span className="radio-text-padding">
                                                                {item.name}
                                                              </span>
                                                            )}
                                                          </label>
                                                        </div>
                                                      ))}
                                                  </div>
                                                ),
                                            )
                                          );
                                        })()}

                                      <div>
                                        <label className="long-text-option">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "q262_rb_received_tmt_unk" + idx
                                            }
                                            checked={
                                              row.q262_rb_received_tmt_unk
                                            }
                                            onChange={Handle262FieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Unknown
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                    <ErrorField
                                      show={row.q262_D_empty_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q262_D
                                      }
                                    />
                                    <ErrorField
                                      show={row.q262_D_txt_empty_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q262_D_txt
                                      }
                                    />
                                    <ErrorField
                                      show={row.q262_DaraNotSelected_err}
                                      message={
                                        BispecificCartTreatmentCohort_Msgs.q262_DaraNotSelected
                                      }
                                    />
                                  </>
                                </td>

                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    alignContent: "flex-start",
                                  }}
                                >
                                  <div className="">
                                    {/* double-dig-answer */}
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id={idx}
                                          name={"q262_rbl_E" + idx}
                                          value={1}
                                          checked={row.q262_rbl_E === 1}
                                          onChange={Handle262FieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Yes
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id={idx}
                                          name={"q262_rbl_E" + idx}
                                          value={0}
                                          checked={row.q262_rbl_E === 0}
                                          onChange={Handle262FieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          No
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          id={idx}
                                          name={"q262_rbl_E" + idx}
                                          value={99}
                                          checked={row.q262_rbl_E === 99}
                                          onChange={Handle262FieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={row.q262_E_empty_err}
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q262_EF
                                    }
                                    style={{ paddingLeft: "0px" }}
                                  />
                                </td>

                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    alignContent: "flex-start",
                                  }}
                                >
                                  <div className="">
                                    {/* double-dig-answer */}
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id={idx}
                                          name={"q262_rbl_F" + idx}
                                          value={1}
                                          checked={row.q262_rbl_F === 1}
                                          onChange={Handle262FieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Yes
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id={idx}
                                          name={"q262_rbl_F" + idx}
                                          value={0}
                                          checked={row.q262_rbl_F === 0}
                                          onChange={Handle262FieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          No
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          id={idx}
                                          name={"q262_rbl_F" + idx}
                                          value={99}
                                          checked={row.q262_rbl_F === 99}
                                          onChange={Handle262FieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={row.q262_F_empty_err}
                                    message={
                                      BispecificCartTreatmentCohort_Msgs.q262_EF
                                    }
                                    style={{ paddingLeft: "0px" }}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
        <div className="survey-section-content-foot">
          <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
        </div>
      </div>

      {showConfirm && (
        <div className="deleteActionModal">
          <div
            className="modal"
            style={{ display: "block", zIndex: Number.MAX_SAFE_INTEGER }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Alert</h4>
                </div>
                <div className="modal-body">
                  <p>
                    <b>{modalDescription}</b>
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleYes}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleNo}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BispecificsCartTreatmentCohort;
